// =======================================================
// BUILDER ENGINE
// =======================================================

const Builder = {

    quantity: 25,

    starterPack: null,

    selectedProducts: [],

    unlockedProducts: [],

    categories: [],

    navigator: [],

    settings: {

        name: "Employee Pack Builder",

        minimumQuantity: 25,

        quantityRules: [

            { from: 25, step: 1 },
            { from: 32, step: 2 },
            { from: 200, step: 10 },
            { from: 500, step: 25 }

        ]

    },

    getMinimumQuantity() {

        if (!this.selectedProducts.length) {
            return this.settings.minimumQuantity;
        }

        let highest = this.settings.minimumQuantity;

        this.selectedProducts.forEach(product => {

            const minQty = getProductMinQty(product.handle);

            if (minQty > highest) {
                highest = minQty;
            }

        });

        return highest;

    },

getQuantityStep(qty = this.quantity) {
  let step = 1;

  this.selectedProducts.forEach(product => {
    const productStep = getProductQtyIncrement(product.handle);

    if (productStep > step) {
      step = productStep;
    }
  });

  return step;
},

snapQuantity(qty) {
  const minimum = this.getMinimumQuantity();

  qty = Math.max(qty, minimum);

  const step = this.getQuantityStep(qty);

  if (step <= 1) return qty;

  return minimum + Math.ceil((qty - minimum) / step) * step;
}

};

const badgeIcons = {
  "recycled": "🌿",

  "bestseller": "⭐",
  "best seller": "⭐",

  "made in uk": "🇬🇧",
  "madeinuk": "🇬🇧",
  "made": "🇬🇧",
  "uk": "🇬🇧",

  "fast": "⚡",
  "fast delivery": "⚡",

  "new": "✨",
  "premium": "👑",
  "recommended": "❤️"
};

const SHOPIFY_FILE_BASE = 'https://kaboom-branding.co.uk/cdn/shop/files/';

// exportStarterPack() // 

const starterPacks = [
  {
    id: 'classic-onboarding-gift-pack',
    title: 'Classic Onboarding Gift Pack',
    subtitle: 'A warm welcome made simple.',
    quantity: 25,
    navImage: 'classic-gift-pack.jpg',
  starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcBMCsA0IAOUQCMCuBLANgEwFMAnERAZymAF9EsoBtUAC1QFsBDAF04FozP2WAHY4CZMn04ECOHgDd2AYwwZWPNAHtuonrAAMe1jlIhFqAOJFpQk3lQBGHoo04NGEuVRNuSMpAD0-gDW7JoaamhE7EJ4wgDmAHTOCRhB-op4Qv5kTBpI-gBmuGL+cVYEQjwc3JKCImISmtoEAPqsBLGqCQBWSHEA-HIAvPYA7AAc9gCcUwYALABsIDTMqEjsREHEPN1aUkQ8VooAnoqieOrsODhIGsK8SBUmZpAglta2Dk4ubh4gFK9vJxfAFgqENOF1FEYvEkhoUmkMlkcnlCsUyKVypV1pttrtuMQ2h0sF1egNhmNRnM9ABmGkTPTLeCrV6RaKEC5YMAaIRcvhYYhRHg4LBxbwAdwIou8PAIzm+3B5PF4OSwRE4z1QAElFAQ0MQ4gACd5PRB2V6OZyudwmAEgIEgwIhMIRaGxISJZKpdKZbK5fJFUQYrC6-VEOJlaw8Lk8vlkAVEIUqphqzhkImdVg9PqDEYTezjcY0ubjWDLAC6VCAA',
    items: []
  },

  {
  id: 'premium-onboarding-gift-pack',
  title: 'Premium Onboarding Gift Pack',
  subtitle: 'Make every first impression unforgettable.',
  quantity: 25,
  navImage: 'premium-onboarding-gift-pack.jpg',
  starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcBMCsA0IAOUQCMCuBLANgEwFMAnERAZylDSIEMA7QvAWizAHs7WmArGspYkwDGOPmSxCmBIWyYALNmzxYClEDJxsMJSCACCdAC5zaQrIdWJCM2oawdU0YW03aQAX0Q1YTMmwBmhkyGWkJyTDhYdATMdGwWaIoA1moaWjogACI0REkABADiRAQAnqQg1my29nSOzq4knhUlBL4YaEwAthgA5hSQoGluukWl5ZXVDrr+GDg49ekeiNT0jExoNJ2JsgCMsADuTPtYxTgEZGTCcjk9xKkui7oAQpvb49JVNHZTIKJkggQ6D1aAA3GIeJpYKAAbVAclQKwYMRY7E4YB4fAERGEf3Ekg+8kUyks6lQBmMpnMJLwdSGJHIqDkhkMSDIkAA9OykjRtp11rQGFEegA6GTCjBJdlCPB0dlkBRIdn+XDndn0Ck0MwWFEcLi8fiCBRKFQAfU6MSwGE6wu4SB6AH4QQBeHYAdgAHDsAJwAZndPoADO6lnDUN5fAEgiEMGEIlFkXEEslykJUNlcoVimUrLSHm4GbomSy2Zzubz+ashaK2OLJdLZfK2IrlWcyOy8DkkkxgaUmOHE60kDQ8GQTUJXQAWIQBicANgDTFn0E9TDnPPWaGgTjgBFg-h2PJ2-ldPrNFqtNrtjpdrpPs-dc690BDIHhujwLTaHW6fRTqFG2YVKgMxzAs+YgP0r7MqyHJcjyih8oiyhAtWtZSjKcoKkqKptj2JRMB+rRkO0XS9GeygXraDrOm6t5ejs96zrOL5vugAprBsWyKEweyHMcpznJcYQ3HciCps8ryKOMqB-ACQKguCBZQcWsFlghFaCihYoSuhDZYS2qqcdsPEHEcJwEK2QnXEQtxEORlrWlR15uu6y4+q6sCuR4AC67hAA',
  items: []
},

{
  id: 'summertime-gift-pack',
  title: 'Summertime Gift Pack',
  subtitle: "Sunny essentials they'll use all season long.",
  quantity: 25,
  navImage: 'summertime-gift-pack.jpg',
  starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcBMCsA0IAOUQCMCuBLANgEwFMAnERAZylDSIEMA7QvAWizAHs7WmytjamcWAOYALAC4B3AsPFMCAYzZNFYsRyZjuIrETGUQinGwwlIIAMJEMZEQTwACALJY6exIUW0xWDqgCMymxGJiAAvogAzAAcAAwRTABmbDQAthpW8gDWxGTKNEgUkKCGxqYgAOraYgT2APT2AKIpxDT4pCAebF4+dKgJGDg4gcEk4eipaGxKRPK5RAoAnvI4dtwYdEI4NGRkBIXFQaWoAOLzBL3uCl003r5mASUhoWNYUADaoCKo1PSMLOycMDcXhEfiCUSSaQQuSKQKqdSaGw6NwGVCWay2BzOVztPD+YZHciocRiAqQWq1TI0SZsNI-BguIQAOkUTIwmVq8jwdFqNjYSFqCVwe05VhsdhSLk0rA4XB4fBoGi0yLIAH1mngsBgUkyAFZIIQAfgAbgBePwAdiifiiUQiABYorAwvBPqhonFEsk0mIMtkiLl5PkKIh5KhKlhqnVGs1aG13H0BkNHiQiWYSWSKVSaXTaAyNiy2GyOVyeXyBUKVmRahIqgQ5LHWswPRF1XYtTr9UazZaLQA2GIxaB96AWl1usxoCZTJgzOaLZarMjrTbbXYh1FmU4Ec64-Ep9qFEAZsjkynUqa536MwvFznc3kifmC4XVoRnOhMKcpGmz2azhcVmYZcNi2HY9jbTVtT1A0TXNK0-GiCILVge0wgAXVCIA',
  items: []
},

{
  id: 'commuter-gift-pack',
  title: 'Commuter Gift Pack',
  subtitle: 'Everything they need for the journey ahead.',
  quantity: 25,
  navImage: 'commuter-gift-pack.jpg',
  starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcBMCsA0IAOUQCMCuBLANgEwFMAnERAZylDSIEMA7QvAWizAHs7WmArGspYkwDGOPmSxCmBIWyYALNmzxYClEDJxsMJSCACCdAC5zaQrIdWJCM2oawdU0YW03aQAX0Q1YTMmwBmhkyGWkJyTDhYdATMdGwWaIoA1moaWjogACI0REkABADiRAQAnqQg1my29nSOzq4knui0DDFMaDQAtomyAIywAO5MA1jFOARkZMJyOQDmxKku6agAQl095ZXVDrqiZIIEdLO0AG4xHohxJzTDowTjk1I5mHgUkKBpbroA6nLmlhVpFUaHYdiBevVlk0gUQ2F0mABmAAMSM6OGCGG64yITDwWjQ42GNBw42YhlO9yYnQws0WDVWOAwAK2IJqqAhn0aiCwnSQNCEQRoAxyBCYxSEJREbX6TAAbFIzkQSngaCV2vyknyhCl3uoll8QAA5GgnMpWGGssEc-VckBEIRTcWS0lMJB7OySMgYI57fZvD421DG02bC2g2q6a30prQBFMGgYEJMNgCOhMTHUe57OnLXTBs2AmyWiPgyFudxNLBQADaoDkqCuNxGYwmUwIzwwr3KQlQv3+m3ZZZI5FQckMhiQZEgAHpp0kaD1Ou0WsojgA6GRrjBJadCPB0adkBRIaf+XATaeN24tx7togvMgAFgA+p0YlhMWvuEhZgB+E4ALy9AA7MBsqPo+-TQL0Fx1qgMJwkuyKouihgZtiuL4oSwokm05ImpS1K0ogPa6CsjLMoOnLlG8IBjhOU6zvOi7LvQq6zBubBbjue4HkeKanueZDTgSTJSDYiEYlixCvu+n7fn+gEgaBsAIgAnEiamwLBdGoDyWqCsKxRitIzrSj48oEIqyqquq2paikJFBiaBZ4FRgYjro9GTjOc4LooS7UGxUQcZu267vuh7HoJDyXi5LC8vyQRWcQNlqqISAhEgdmahqsnKPJP7-kBwEABzQI+KK9LK2meHBuj2o6plSswbp8B6vjerMvoTN2zkhlY7n0p5dHjj5TH+WwgUriFnHcRFfHRWesV0PFjUmRKLWdT6YgTPGPoEPlH6dF+RVKWVvQQb0SKlWpOn1rosbxomsgpoc6bdGM2ZOXmLkDpGQ40aOY2MX5LFBQws1hTxkX8Sey0XqtppME9CZJm9aYZl9fBHYViklcBN29L0FUIh4AC67hAA',
  items: []
},
  {
    
    id: 'welcome-essentials',
    title: 'Welcome Essentials',
    subtitle: 'Perfect for most new starters.',
    quantity: 25,
    navImage: 'premium-onboarding.jpg',
    starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcBMCsA0IAOUQCMCuBLANgEwFMAnERAZylADsBPHAeyoFo8iBDAdzIBcisqA5kzRsBFSKADG9BhhKQQATQI4GHUiELT23LI1QBGJtNkkAvojz0kSYk3p8B-NjmH1u3HASYAWWAAYAWxxKEBN6OVQAZQwqMgALfgIAAiikHDYEjS0HNl19BQAzDFVjGQjzSxlJbxr2QKxJJkCMMVDwyIUAdUTuAmyCbTy9KkMy0xALZDYiAGs7ACt3PqImIkGaSS88YRccJHp+biZbUYkw8s6lFTUBofyzkCMOypAcDECCZg4sda8yMjGeIzAR2ESBND0ejGBiSWbtS7yEAAITYEKhd1yDzGL0miGkgSQbEkx3mND4giY3AckniCImCmUqno6ksgyxIxxiMmUywUAA2qA6QpaAxmKxODwKUIRG18agmbdLFyJuRUPEPEgyJAAPQ62ZsSH0QLCdhUPD8AQAOmkVowsx1kjwVB1CWsOsKuAIZB1NBuLKYosYLHYXF4lt2YgA+p8LR8rUhBAB+ABuAF4DAB2TPQADM-gMBmgAA48ULUFYbHYHFgnFQXG4PF5fAFghpJNFYgkkql0pk6cqiiVXLi1QoNdwtbr9YaoSa0GaLYIbfQ7Q6nS63UgPV6fWQu4kqN4yH2EixrLYiH4gjgYwQ44ErQskAJUxnswA2LPFnz+HxlkBhU0apamINFGmaVoKHlbpen6QcnnGCoNHEQDNW1PUDSNedF0tFc10dZ1XXid1PX+HUODg88cBqSDo1jLB42fV90yzHMCxLABOD8AKAok5kWZY7HWSRNm2XZVAOI4Ti+dsFX9VlNBVZCxzQycMJnbDTTYc08Nte1CM3EjtzI71fQUk4ZnmVYlg8Yg7wfJ8XzfNjf1zXNM2LfxeNQd5Pm+X4VG9QFaRBME0SNGF6DhOSFFRdF6GyZTIlUicp0w2djW03Tl309ciK3HdyL8r5dgSqK4SBMKiAcxjH2YlzPx8AwfC87yLHLBQCSJEkmDJaUqRpAcwnk5lFLwZKSFS9DpywudsqXa08sM4jSN3cyxsGohaT6ghyUtWqmOc1js1gAxc04zj3MmABdMwgA',
    items: []
  },

  {
  id: 'financial-services-onboarding-pack',
  title: 'Financial Services Onboarding Pack',
  subtitle: 'A recommended starting point for financial services onboarding.',
  quantity: 25,
  navImage: 'financial-onboarding.jpg',
  starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcBMCsA0IAOUQCMCuBLANgEwFMAnERAZylADcsA7AcwEMBaNRnAFywFsB7IgswEBjAJ7CcBPMzIdGdSWTIyOBAjla8OHScwBsABgPcclEMN45eGEpBABxAQVqkQhC0UZdeLuwEZmCysbEABfRBoGFjReMkkiIQIxCSlmPz1mHEYkDl4kGUkCKgIzIOtbBycXRHd+LywfVAAzDBwNMpDwkEimTTjiROTJaVotAhjeAGtSy3LURzVqtyS6718QAI6SLqRGIkmBgCstVQSRcWHWdhwkXjoOZiRnGeCKgHUACyxVV1rPNdQm1mnUQaE8tEI0jY3AmaVgAHdmPCsAJFMphB89vRiC85nYAEKMGG8Xi-Fb-BrrIGvMJdLBQADaoA+qB60XYXD4AkGF1SsnktDRKjUGhi2l0hmMpkQwnmVV+gMCwJI5FQH20SDIkAA9NrJowJtxWOC8HR6AA6CzmjCTbXCPC0bVkD55bVNXAEMja+hVZhsq6cHj8QRinQEAD63CkWAw3HNhyQ9AA-FQALx+ADsAA4-ABODMAFmgGYMYXgzNZZuisXiPJS0nSmWyuXy-SKJRlcsWCrsLTaSppqrs6o4mp1eoNJKNYMYELNlt41tt9sdztd7sU3t9-qyOTyBTUxUj0dj8cTKfT2aL0D0AGYM9AyxW7P6Yv0zkleSMxhNpp27Aszw1IqWyuBQw4alqur6oaxqzqaDALkudoOk6LpIG6Hpej6ix+lWfS1qMqi-sepqngmyZppmWbXlmeh6BmT4gCydi7PsRwnAM5z1gGNx3LQDxPEssp2J83wdm4IHKmBaqQeOMFTnBc6IVaNooau6GYZu8JfKojx7AcCTHNoxCkTGcYURemaFgYt73lmpbhM+6Amqk0Kwn4CJIii6ieuimJENiKrmKghLEqSwH+AOcxDsxcnQZOvDTia86qcuqFrhhG6etq7kknCiLIqifmBAFQVmeR55Udm0BZvesBZo+oQALqhEAA',
  items: []
},

  {
  id: 'working-from-home-gift-pack',
  title: 'Working From Home Gift Pack',
  subtitle: 'Everything they need to feel part of the team, wherever they work.',
  quantity: 36,
  navImage: 'working-from-home-gift-pack.jpg',
  starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcDMBsA0IAOUQCMCuBLANgEwFMAnERAZylDSIEMA7QvAWizAHs7WmArGspYkwDGOPmSxCmBIWyYALNmzxYClEDJxsMJSCACCdAC5zaQrIdWJCM2oawdUAJmFtN2kAF9ENAKxMybABmhkyGWkJyTDhYdATMdGwWaIoA1moaWjogACI0RCkABADiRAQAnqQg1my29nROLm4kXui0DHFMaDQAtsmyAIw+AO5MQ1ilOARkZMJyeQDmxOmumagAQj19ldW1DrqiZIIEdPO0AG5xnojU9Iws7JxgnaWGISJiElIyLq8cof5ycaGZZNdaiIRpKzSGo0Ox7ED9RqrFo0WBMPAYWQBYKhcKRaKxeKJAh9FJMJA4DAzAT1SCgDLuXRrcGQqrQ3a0hFI9wtISbIhYPCLJjdDDzCh09QrRkgZk0CHbdmwuqoREM5rkMbTckEGhk0pCMoiDr9AAMIzGEymMwiC0E3S0h26sJBqyZLMVNmV8IORxO50uHhaWCgAG1QHJUDd2sxWBwuNQCK9hAdxJJoT8wnR-mRAURgYghGD5ay8KruSRyKg5K8kGRIAB6BspGh9brPW4xeYAOhk3YwKQbQjwdAbubYSAbgVwUwbaBZ93jT0TyZCuaBZAA+t04lgMN1u9wkPMAPxnAC8-QA7AAOfo3q+wRyOaBXCOoVHozH+IIhMIYCIohiDoEiSVJyUpaljkqIt3RLbZy3VSoJRAGtDDrRtm1bRR22jZQTl7Nh+0HYdR3HSdp0mMg5wXT9sRCUCSVSGYMTYbdd33Q9jzPS8r0fWBTVgaAABZTTfVDUD5XoBSFAgRTFChC2LBUrEQ6VKxAFC0IwpsWzbDsGC7QjiKHEcxwUCiZ2o+cS2EflBWFUVxXY5ROKPU8L2vK9+gATivU1HBvMSvHfXQyC1KC9SYA0jUmZgzQtcYCCom05iIRYiBFR0CGdAt1GU0tUF9TLjlOGgLjLKtdG0+tdOwthcLafCez7AdTLIiypysscIoEKKYuNeLTQAdVGJKUtmO1ModKkcthaAXL3A93J468b0C6Abx8YTYE8ABdDwgA',
  items: []
},
  {
    id: 'onboarding-gift-pack',
    title: 'Onboarding Gift Pack',
    subtitle: 'Because every great journey deserves a great welcome.',
    quantity: 50,
    navImage: 'core-onboarding.jpg',
    starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcCsAMA0IAOUQCMCuBLANgEwFMAnERAZylAHY4BbWgWjIDsBDJMrJJpAeyIAuZBml4CBOAhUigAxrxy8MJSCADCk1kQAEAem0B5Iq2YBzAtoDKbJJa6kQhecYFZezVAEYG8xcpAAvoisAGwMeBi8TLwAZgIMAkqyABYMOFjMBHgMzGIEorwA1gxIOBjCSAQeMiC+SiogAIK0aMQOTvysru5ePgr1gYhoxswpIqwtvFHlaAzJGGiUtf3+qgBCEwXtBM5dbtUg3nX+QSC0U9kZZBg4XVl9MTEEBD4YKDXHDUYm5tu73QcjisSKcBKwoqJxJIGLxKpkiAxCgQAJ5EDKmJafVDfMwEP6dAG9LEBU5YKAAbVAyVQNFg9CYNk43DIfEEwkhEikDlkqA0BC0ekMI3MVhsdhQiDwROBDmkIGS4g4kF0ukKrAKjGGJjw6IAdPJdRhCrpZHhmLoyMlYboYrgpBbGVwYcKXiz+EIRGJOQB9WhZLAYWi6gBWSFMAH4AG4AXk8VCongAnNBoJ4QonBlTUKFwpFonEEklUulMtlcgJ8lNiqVyiUqtzUM1WiRJdK-C2QHKFQIlSq1RqRCMdWZ9bxDcbTebLdbbZIyLpNsQGDmyLF4uXK0VhBFeL7-YGQ2Go7H4yEQrAQgBmAAssEz8tQWtGqTQmymDBmcwWDfWb947TbAZyFQbte1VdUpk1Ic9QNI0TTNC0rSQG07XnJ8xk-eY0AAJj3HUD1DCMYzjKgQmvS8AA5L0vO8gizVRzl4S5mGuW4K2yeRHmeV4JVqbEXQA1QgXbWUQMVMhlXAgcn2HUxR3HeCpyQlC510TpcQYRiONiJ4XloDBTDwgMg0I48SJCbDoCoy9sPvalVDBCEvWhWEqiXJFUXRH8QBxX5WyEvoROA1RQIkvsIN4KDtRgsc4MnRCZ1QtSXQScFPShF5XPhREUTRMwjIIo9iPjcizyoRNPECABdAIgA',
    items: []
  },
    {
    id: 'summer-beach-gift-pack',
    title: 'Summer Premium Beach Gift Pack',
    subtitle: 'The perfect way to thank your team for a job well done...',
    quantity: 25,
    navImage: 'summer-gift-pack.jpg',
    starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcBMCsA0IAOUQCMCuBLANgEwFMAnERAZylADcsA7AcwEMBaHR+gexaIIGMBPXjgJ5mZAC6M6wsmTHiCBHMzQdx44cwBsABh0BbHJRC8OODhhKQQAGSz0AFuIAEAIRwYCpEIVNFG4lgctKgAjMym5pYgAL6INAwsDrgczDwCQiIRjLRUjHL6jAAeWMziagQq7MwALHr0ZPrGkRZWIADyAGadzgDqyQrevhz+gcFhEWatsYhIRHQKovTCjPppvHLpgsKiZBgMbLIEFJCgLdHW7p5DfCMBQSHW4eckcSAJTKzsXGl821mmdTBFQERi8BxlDgAdyUzSmF1s9icbg8XkQw1GD1QBH0aCIHCwhB4eBm6H8tEIog+LBacjQoPBZQItFoWDkTH0XlOJnhbVc+KhIXRt0x4yekyir0QeJylOY1OYjBwaG4f0yoiQWF4rN4KjYtAA1gRxMx9KJQgBmHRFUIAdh0vCa3JeqAAcowqPwbn57mKQJ0MDhlC63haABw6C3MTpcNbiIgYXhGohyXiMJAnM681AAZQN-GcAHpnO7Pd67mNHv7A8HszE3lgoABtUAOVAKticVUZHbyKS0GRyCSKZSqdSaXQGIyIXioOyOFxXNE+CYu8ioJziDOQQuFg2MVQcNYyil0egAOlM54wBsLvDwtELZAcHCQhc6uGOhZwSPEaFR8pniwnY-GOGgEAA+pyeBYBg+jngAVkg9AAPxUAAvHaYahAAnGGWhaKEWgzK27ZAcwyTmL8PYAjkeQFMUpTlAoVT0LU9SNN4s7WF0PT9Fggzoqu2brtYm7bru+6Hse5IwQwl4cNet73o+z6vu+n5kIWHDdFCAyVAqlGpFs6rZLk+RQSIsHwUhqEYVh0A6LAOFaFaJEgG21hzAsWTLKCaxEBs1H-Ls+zLPkZDHFxqBLkMwmSt4JweeoEl7geHBHioslngpSl3g+T4vm+H4yIW-6eMwfmrGIYWHJFcg5H5lkwXBiHIWhmG2thFq2tA4ahO5nnvORIHdiFkxArQIJghC5QwtOJhzr+KLXEJ1g4niBJEiIiUbilZA7ml0lZbKOVXje+WqUVGmlT+C7lQZI3fGNpn0jNkLzc11ltXZnVhn1XU1LatqDagJ5ygqtLTYyCgsmylWrMu3EgPy0JCiu4priASXiQdknpZl4NnYpF0qYV6klV+kNTHSDKzcyrLsojoRfa1tkdQ54bQBGA1xKR1jg1kCpKiqwWmZq2panqORGiaZrMJa1p2g6TQzm6Hpemt1ZBhK0yiclW540dGUyad8nncpBVqcVmmFrQGuAYkirKi9vYSzq0uGsaCtWja9qOqzNntfZXV9WGsA1FoNSg9Y4aRtGsZlAmSbEKm6YUGr1h5gWxalprGPa7WCX67jh1SSbJ2nubJOW1dFO22Q+bMPbnrMHHFqBz9HPA5O0BaNAIMxAAujEQA',
    items: []
  },
  {
    id: 'premium-event-gift-pack',
    title: 'Premium Event Gift Pack',
    subtitle: 'Leave a lasting impression with gifts your guests will genuinely value.',
    quantity: 100,
    navImage: 'growth-onboarding.jpg',
    starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcCMAMsBoQAcogEYFcCWAbAJgKYBOISAzlKIQHYCGAtobgLQDGjy2NA5iw5h5UQbAPa5RmUpBAAhXJkIACAPRKA6gAtsAF0JkQRMcTo7sommmjtxk0gF8kDUzpbkddbrkLlybvcwsAG50bJiYDCzoojo63iwArPAMuMJiElJoAHJ0QQCeII4gDKKi+MGh4ZHRsd5+SbApabaZMgAidMQA1kryigZGoiZmFlY2GQ5IzIRsOiYsPMR+xDN5bN7l6HS4uMi0zRNoHd29CvpIg8PmljLW6XaFSHvILAAs8LD8dJosyKIA7iQonQaF0Dg8ZAAZbA8TQ6U79C4zIama5je6ZIo0UQhFj-bArOp+QidLD4SiQUAY6QgLS6c6GZFXUa3cYPIqaUl2Fg6GKEFgAK0wemBQkpIhaNJyOik21UCIZl1RLJAd0ljxAmBo2CCJHI2x5EXQ3mIb2SqXF1KOnR6fWUajpeiU0PwAyZypuqrZmKQr2gAE5-VFiJhyJpCOVw7k8jZYhZ2HRkBSqeqZLJCDD9EUAMz+gBsedjvJoPPxOxYheQIMCHCT4NaIBy+Tdxg9aEIDHQxFE2CIK1dRQAZrhOvyVmw1hsWFOanF+aI9jQgV1CHliNwxSnDjIAEqiPLbFsokaetWHIoAJmsdGFohYC9o7Ak5H5g-E+Doxv5YgYVdmLHHScI1+QhXCNQkR3rKVoyPZlT29BwimwKAAG1QE0dt6CYVgOF-Dd+EEAw2DQO15UdRV0XVCg0DhHQk0gFQVC6T9SmqEwaHwDcADoxC4zAuhUNh8BoFQwwXFRBzwHwVGNRQWFoRga04fCBB4AB9JhOIiLiBWQHgAH4ggAXmgAB2UyL1gV5-QSANHnQtASjKCowgiKIYjnepzSI60TjtAZKMOaiZFo+jGOY6JRDYkFON4HjRD4gShJEsTkAkqTyBUD9ulk-knM2DzvA0iNsG03SDOMsyLOzPMAA5swSBJ7JADCZGmWZ5kWZZVnWYCth2RcfPaG0FQC1krWClrYjCpiWKi4MYu43j+ME4TRM0cTJLqLKbVy+TvA6ugFiWACeqnRdiq0hgdL0wyTPMv1YFq+BXma1qUEIF53ngL4fj+QFTS2UEhpAaFYXhfyLkCh5JtC8gGNmyLoo4paEpW5L1s2jKVFwGE4T255fgBIEga6NS2A4C8kjoBJEn9Bq3hpoNaoSNhXhYf1asHdBB39QdYHwC9Xlqy7Suu8q7qq14r2F2BszetBsVxfFCR8YlSUwckQfIsavQmkAKSmuj4fCubkdinh4sS1aUo2tKtukpWjpV6ZfHkjXyVeUWytuyrzLzV4-QSK8FZCrkpB5PlBWFfktiEJBiJkaVZVweVIcMaHMlh6aTcR1iFpRuLlqStbUvS7a9qFEU4-Ib3xd9+7qvgC8W9DzVtV1JYDRlTsTTNRpUgT3zbTOMjtCdF1dbPGGDZonOEYi-Ou0Wou0ZL22se27Kuj2-5x-5LUdT1bujRNOuboqxuZYvXN-Tb3MCyLeMdDLVhK2rHDE0oIek5gqG2s7N2XsJAIwGENnDBeZsC4WytujUudty6O2jCwB+eZz4Sz9qZBI-poCNWgNANuw5RynQnL1coM5CrzkXMuVc65eAgz3AeQeGdxpUVniFeepskbQNRtbDGZcHaZW7EwkhQFyiQgAKJtHcrUKhtAaFrg3OghuUtXjB0DrVNuV4WA3l5PeRcT5RAvhYG+Agn54g-j-K4QCZCQJgUAcwSCP9Gx-xYXrNh4DOF53msvQulti420xvbbG9B8gsG0aYj8X59GPnWEY78UUrGiNsXsexXZHF0GUZfKq2YW7QFqtAV69gAC69ggA',
    items: []
  },

    {
    id: 'exhibition-swag-pack',
    title: 'Exhibition Swag Pack',
    subtitle: 'Designed to draw crowds, start conversations, and leave a lasting impression.',
    quantity: 250,
    navImage: 'scale-onboarding.jpg',
    starterUrl: 'https://kaboom-branding.co.uk/pages/pack-studio?pack=N4IgjiBcBMCsAMAaEAHKIBGBXAlgGwBMBTAJxGQGcpgBfZHKAbVAAt0iA7AQwFsi8AtAGNeKHBwDmAnlgnkQQ9ACE8XIQGsABAHpNAdRY4ALkXkF0ARmEB7PNaxlK6FkaMoKkbdvVcM16zwCGCRcHATiEgB0QtaRWOraQgQc2hQs1ijaAGb4RBTaGKoaApy8-MKiEdKyAPp84Vg8kQBWKBIA-ABuALwWAOx90PAALACcsBajIHSs6H0IPIISJDgoAhQo1iRGFEHWrnhEAp1ceJ1HeDjmyIqQICpqWroPGpoAMldmljZ2DvJUdxcbg8Xh8fgCQRCYQi0Vi8USyVS6UyOUO+UKjyCRXUAmWq3Wm22uz8BzyAnm8B4PDqRAaTVaHR6-T6FngAwsFmg00QszuXD66yMOA0AE8BBx9nl5LcQAZjERNAAFLgoUhfO5WGK-RwgAEgIHuTzeXz+QLBULhSSwuIJJIpNIZbK5fL8wXC9RiiUmAQoLgECg0uktNpdXoDADMfQAbLAAByTbm8hTWDhGewkARZEjWChGH2cKg3ZTY9UgTW2dP-ZyuQ2gk0Q83Qq0xG0I+3Ip1o7TLIhimKp9OZ7O5-McAP1HCNYOMsN9YbwSasqOJ-XobNGLjejBcCjCgTh6ASDACLAUY9ZVRpAQEFbnaXFx6l8vaquAmsg43gs1Qy1RFvwu0kUdVE8gKbEBHXTcjm3XchH3Q9j1Pc9LxYa9byIQNJ3pEMmQGYYLFjeYWRXNg7m4IwHFOGxXBTAQ0y3LgJELBR0AAOU3Si8CfH5KycN9gSNMFTUhC0YX-W1EQdFFnW0cjOOotMODoyUgkY8daSw6dQ2ZA9hlgBAuRmVc7nDWN4HDTNrF4OiSCwDRSF2ER3HvO4XnUUssiwPBBC1XjdWrAS6y-ESmz-OEJPbYCZIxYpTPMzCpwZbSBijeB4GgKNoD6EjLFgKlM1UPNNjwEU8hMDNVA4EUuBIf0XPuEtkHMDUeL+Pj9XfQT62-UTm3CtsgOkrsYpxCw8sCSrqtq9SgyS3C530hd+hyu4AHccDSPwOCOIxs283sbHEAR1F7FZJB9M6TGuFi7lY91+A8ryfIrNr-P42tP2Extf2tADJI7ED8hQS7aQEdbNpTHa9sOPtrHEBLsJnZk9OgaBhljYYVtQWABDUEgRUuOCTpFM6mPqgBhQ4as0ABBIR8cJ7jfNevUDQ-ISGx-MT+sAqTO1AxUceJ0mZs0ubZ2GOB5lGQyAF0aCAA',
    items: []
  }

];
function getStarterPackImageUrl(fileName) {
  if (!fileName) return '';

  if (fileName.startsWith('http')) {
    return fileName;
  }

  return SHOPIFY_FILE_BASE + fileName + '?width=420';
}

function cleanPackStudioUrl() {
  const cleanPath = window.location.pathname.replace(/^\/+/, '/');

  window.history.replaceState(
    {},
    document.title,
    cleanPath
  );
}

function buildStarterPackCarousel() {
  const carousel = document.getElementById('starter-pack-carousel');
  if (!carousel) return;

  carousel.innerHTML = '';

  starterPacks.forEach(packData => {
    const card = document.createElement('button');
    card.type = 'button';
    card.className = 'starter-pack-card';
    card.dataset.packId = packData.id;


    const imageUrl = getStarterPackImageUrl(packData.navImage);

    card.innerHTML = `
      <div class="starter-pack-card-image">
        ${
          imageUrl
            ? `<img src="${imageUrl}" alt="${packData.title}" loading="lazy" decoding="async" width="420" height="280">`
            : `<span>🎁</span>`
        }
      </div>

      <div class="starter-pack-card-body">
        <strong>${packData.title}</strong>
        <small>Starts from ${packData.quantity || 25} packs</small>
      </div>
    `;

    card.addEventListener('click', () => {
  if (pack && pack.length > 0) {
    const confirmed = confirm(
      `Starting "${packData.title}" will replace your current build.\n\nDo you want to continue?`
    );

    if (!confirmed) return;

    localStorage.setItem('previousEmployeePackBuilder', JSON.stringify({
  pack: pack,
  quantity: currentPackQty,
  packageKey: 'builder',
  starterPack: currentStarterPack
}));

    localStorage.setItem(
      'previousPackStudioSelections',
      JSON.stringify(packStudioSelections || {})
    );
  }


const url = new URL(packData.starterUrl, window.location.origin);
url.searchParams.set('starter', packData.id);

window.location.href = url.toString();
});

    carousel.appendChild(card);
  });
  updateStarterPackHighlight();
}

function updateStarterPackHighlight() {
  const activeStarterId = currentStarterPack?.id || null;

  document.querySelectorAll('.starter-pack-card').forEach(card => {
    card.classList.toggle(
      'active',
      card.dataset.packId === activeStarterId
    );
  });

  if (activeStarterId && activeStarterId !== lastHighlightedStarterPack) {
    scrollStarterCarouselToActive();
    lastHighlightedStarterPack = activeStarterId;
  }
}
function loadStarterPack(packId) {
  const starter = starterPacks.find(item => item.id === packId);
if (!starter) return;

  if (!confirmReplaceCurrentPack(starter.title)) return;

  if (pack && pack.length > 0) {
  localStorage.setItem('previousEmployeePackBuilder', JSON.stringify({
  pack: pack,
  quantity: currentPackQty,
  packageKey: 'builder',
  starterPack: currentStarterPack
}));

  localStorage.setItem('previousPackStudioSelections', JSON.stringify(packStudioSelections || {}));
}

currentStarterPack = {
  id: starter.id,
  title: starter.title,
  subtitle: starter.subtitle,
  quantity: starter.quantity || 25,
  originalHandles: []
};

updateStarterPackHighlight();


  if (starter.starterUrl) {
    const url = new URL(starter.starterUrl, window.location.origin);
    const sharedPack = url.searchParams.get('pack');

    if (sharedPack) {
      loadSharedPackFromString(sharedPack, starter);
      return;
    }
  }

  currentPackQty = starter.quantity || 25;
  Builder.quantity = currentPackQty;

  if (qtyInput) qtyInput.value = currentPackQty;
  if (sidebarQtyInput) sidebarQtyInput.value = currentPackQty;

  pack = [];
  Builder.selectedProducts = [];

  savePack();
  updateSummary();
  updateProductAvailability();
  syncSidebarQtyUI();
  buildBuilderNavigator();

  updateBuilderIntro(
    `Building: ${starter.title}`,
    starter.subtitle,
    starter.quantity || 25
  );
}

function scrollStarterCarouselToActive() {
  const carousel = document.getElementById('starter-pack-carousel');
  const activeCard = carousel?.querySelector('.starter-pack-card.active');

  if (!carousel || !activeCard) return;

  activeCard.scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest'
  });
}

function confirmReplaceCurrentPack(starterTitle) {
  if (!pack || pack.length === 0) return true;

  return window.confirm(
    `You already have ${pack.length} item${pack.length === 1 ? '' : 's'} in your current pack.\n\n` +
    `Starting "${starterTitle}" will replace your current build.\n\n` +
    `Do you want to continue?`
  );
}

function hasSavedBuilderPack() {
  const saved = localStorage.getItem('employeePackBuilder');
  if (!saved) return false;

  try {
    const data = JSON.parse(saved);
    return Array.isArray(data.pack) && data.pack.length > 0;
  } catch {
    return false;
  }
}

function showSavedPackPrompt() {
  const savedPackMessage = document.getElementById('saved-pack-message');
  if (!savedPackMessage) return;

  if (pack && pack.length > 0) {
  savedPackMessage.style.display = 'none';
  return;
}

  const saved = localStorage.getItem('employeePackBuilder');
  if (!saved) {
    savedPackMessage.style.display = 'none';
    return;
  }

  try {
    const data = JSON.parse(saved);
    const count = Array.isArray(data.pack) ? data.pack.length : 0;

    if (count > 0) {
      savedPackMessage.style.display = 'block';

      const btn = document.getElementById('continue-saved-pack');
      if (btn) {
        btn.innerHTML = `
          Continue Last Build
          <span>${count} item${count === 1 ? '' : 's'} saved</span>
        `;
      }
    } else {
      savedPackMessage.style.display = 'none';
    }
  } catch {
    savedPackMessage.style.display = 'none';
  }
}



function restoreSavedBuilderPack() {
  const savedPackData = localStorage.getItem('employeePackBuilder');
  if (!savedPackData) return;

  try {
    const data = JSON.parse(savedPackData);
    currentStarterPack = data.starterPack || null;
    updateStarterPackHighlight();

    pack = data.pack || [];
    currentPackQty = Number(data.quantity) || 25;
    currentPackageKey = 'builder';

    Builder.quantity = currentPackQty;
    Builder.selectedProducts = [...pack];

    if (qtyInput) qtyInput.value = currentPackQty;
    if (sidebarQtyInput) sidebarQtyInput.value = currentPackQty;

    showBuilderState('builder', 'Pack Builder');
    updateQuantityUI();

    setTimeout(() => {
  restorePackStudioSelections();

  Builder.quantity = currentPackQty;
  Builder.selectedProducts = [...pack];

  const mainQty = document.getElementById('pack-qty');
  const sidebarQty = document.getElementById('sidebar-pack-qty');

  if (mainQty) mainQty.value = currentPackQty;
  if (sidebarQty) sidebarQty.value = currentPackQty;

  updateQuantityUI();
  updateSummary();

  restoreAddedButtons();
  updateProductAvailability();
  buildBuilderNavigator();
  updatePreview();
  syncSidebarQtyUI();

  const savedMsg = document.getElementById('saved-pack-message');
  if (savedMsg) savedMsg.style.display = 'none';
}, 300);

  } catch (e) {
    console.error('Failed to restore saved pack:', e);
  }
}

function loadSharedPackFromString(sharedPackString, starter = null) {
  if (!sharedPackString) return;

  try {
    const decoded = JSON.parse(
      LZString.decompressFromEncodedURIComponent(sharedPackString)
    );

    currentPackQty = Number(decoded.q) || starter?.quantity || 25;
    Builder.quantity = currentPackQty;

    pack = (decoded.i || []).map(item => ({
      handle: item.h,
      title: item.t || '',
      colour: item.c || '',
      decoration: item.d || '',
      imageSrc: item.s || ''
    }));

    packStudioSelections = {};

(decoded.i || []).forEach(item => {
  if (!item.h) return;

  packStudioSelections[item.h] = {
    colour: item.c || '',
    decoration: item.d || ''
  };
});

savePackStudioSelections();

    if (starter && currentStarterPack) {
  currentStarterPack.originalHandles = pack.map(item => item.handle);
}

    Builder.selectedProducts = [...pack];

    if (qtyInput) qtyInput.value = currentPackQty;
    if (sidebarQtyInput) sidebarQtyInput.value = currentPackQty;

    showBuilderState('builder', 'Pack Builder');

    updateBuilderIntro(
      starter ? `Building: ${starter.title}` : 'Building your saved pack',
      starter ? starter.subtitle : 'Customise your saved pack below.',
      currentPackQty
    );

    savePack();
    cleanPackStudioUrl();
    showPreviousPackPrompt();

    function showPreviousPackPrompt() {
  const savedPackMessage = document.getElementById('saved-pack-message');
  if (!savedPackMessage) return;

  const previous = localStorage.getItem('previousEmployeePackBuilder');
  if (!previous) {
    savedPackMessage.style.display = 'none';
    return;
  }

  try {
    const data = JSON.parse(previous);
    const count = Array.isArray(data.pack) ? data.pack.length : 0;

    if (count > 0) {
      savedPackMessage.style.display = 'block';
      savedPackMessage.innerHTML = `
        <strong>Want to go back to your previous build?</strong>
        <p>You can restore the pack you were working on before opening this starter pack.</p>

        <button type="button" id="restore-previous-pack" class="continue-saved-pack-btn">
          Restore Previous Build
          <span>${count} item${count === 1 ? '' : 's'} saved</span>
        </button>
      `;
    }
  } catch {
    savedPackMessage.style.display = 'none';
  }
}

    setTimeout(() => {
  Builder.quantity = currentPackQty;
  Builder.selectedProducts = [...pack];

  if (qtyInput) qtyInput.value = currentPackQty;
  if (sidebarQtyInput) sidebarQtyInput.value = currentPackQty;

  restorePackStudioSelections();
  updateQuantityUI();
  updateSummary();
  restoreAddedButtons();
  updateProductAvailability();
  buildBuilderNavigator();
  updatePreview();
  syncSidebarQtyUI();
}, 300);

  } catch (e) {
    console.error('Failed to load starter pack:', e);
  }
}

function updateBuilderIntro(titleText, subtitleText, minQty = 25) {
  const title = document.getElementById('current-package-title');
  const subtitle = document.getElementById('template-subtitle');

  if (title) title.textContent = titleText || 'Build your perfect pack';

  if (subtitle) {
    subtitle.innerHTML = `
      <span>${subtitleText || 'Choose products from the sections below.'}</span>
      <ul class="builder-intro-points">
        <li>✓ Starts from ${minQty} packs</li>
        <li>✓ Fully customisable</li>
        <li>✓ Live pricing as you build</li>
      </ul>
    `;
  }
}


function BuilderInit() {

    Builder.quantity = 25;

    Builder.selectedProducts = [];

}

function getPackHandleSignature(items) {
  return (items || [])
    .map(item => item.handle)
    .filter(Boolean)
    .sort()
    .join('|');
}

function packMatchesOriginalStarter() {
  if (!currentStarterPack?.originalHandles?.length) return false;

  const currentSignature = getPackHandleSignature(pack);
  const originalSignature = currentStarterPack.originalHandles
    .slice()
    .sort()
    .join('|');

  return currentSignature === originalSignature;
}

function updatePackIdentityIntro() {
  if (!currentStarterPack) return;

  if (packMatchesOriginalStarter()) {
    updateBuilderIntro(
      `Building: ${currentStarterPack.title}`,
      currentStarterPack.subtitle,
      currentStarterPack.quantity || currentPackQty || 25
    );
  } else {
    updateBuilderIntro(
      'Your Pack',
      `Inspired By ${currentStarterPack.title}.`,
      getPackMinimumQty()
    );
  }
  updateStarterPackHighlight();
}





// Safe closest polyfill
function safeClosest(el, selector) {
  if (!el || el.nodeType !== 1) return null;
  let current = el;
  while (current && current !== document) {
    if (current.matches && current.matches(selector)) return current;
    current = current.parentElement;
  }
  return null;
}

let pack = [];
Builder.selectedProducts = pack;
let packStudioSelections = {};
let suppressPackToast = false;
let currentPackageKey = 'builder';
let currentStarterPack = null;
let currentPackQty = 25;   // must match essential-onboarding.minQty
let lastHighlightedStarterPack = null;
let hideLockedProducts = false;
Builder.quantity = currentPackQty;


function getProductMinQty(handle) {
  const product = window.packProducts?.[handle];

  const breaks = Array.isArray(product?.quantity_breaks)
    ? product.quantity_breaks.map(Number).filter(Boolean)
    : [];

  return breaks.length
    ? Math.min(...breaks)
    : Builder.settings.minimumQuantity;
}

function getProductQtyIncrement(handle) {
  const product = window.packProducts?.[handle];
  const increment = Number(product?.quantity_increment);

  return increment && increment > 0 ? increment : 1;
}

function getPackMinimumQty() {
  return Builder.getMinimumQuantity();
}

function getStepForQty(qty) {
  return Builder.getQuantityStep(qty);
}

function snapQtyToValidStep(qty) {
  return Builder.snapQuantity(qty);
}

function getPreviousValidQty(qty) {
  const minQty = getPackMinimumQty();
  const step = getStepForQty(qty);

  let nextQty = qty - step;

  if (nextQty < minQty) {
    return minQty;
  }

  return Math.floor(nextQty / step) * step;
}


function getCategoryIcon(category) {
  const name = String(category || '').toLowerCase();

  if (name.includes('mug') && name.includes('travel')) return '🚗';
  if (name.includes('mug')) return '☕';
  if (name.includes('bottle')) return '💧';

  if (name.includes('station')) return '📓';
  if (name.includes('tech')) return '💻';

  if (name.includes('laptop')) return '💼';
  if (name.includes('bag')) return '👜';

  if (name.includes('t-shirt') || name.includes('shirt')) return '👕';
  if (name.includes('hood')) return '🧥';
  if (name.includes('headwear') || name.includes('cap') || name.includes('beanie')) return '🧢';

  if (name.includes('outdoor')) return '🌿';
  if (name.includes('event')) return '🎪';
  if (name.includes('umbrella')) return '☂️';

  return '🎁';
}

function buildBuilderNavigator() {
  const nav = document.getElementById('builder-section-nav');
  const activeGroup = document.querySelector(`.accordion-group[data-package="${currentPackageKey}"]`);

  if (!nav || !activeGroup) return;

  nav.innerHTML = '';

  const accordions = Array.from(
    activeGroup.querySelectorAll('.accordion[data-pack-category]')
  );

  accordions.forEach((accordion, index) => {
    const category = accordion.dataset.packCategory || `Section ${index + 1}`;
    let cards = Array.from(accordion.querySelectorAll('.product-card'));

if (!cards.length && accordion._builderLazyProducts) {
  cards = accordion._builderLazyProducts.map(product => ({
    dataset: {
      productHandle: product.handle
    }
  }));
}

    const availableCards = cards.filter(card => {
      const minQty = getProductMinQty(card.dataset.productHandle);
      return currentPackQty >= minQty;
    });

    const selectedCards = cards.filter(card =>
      pack.some(item => item.handle === card.dataset.productHandle)
    );

    const availableCount = availableCards.length;
    const selectedCount = selectedCards.length;
    const totalCount = cards.length;

    const allLocked = totalCount > 0 && availableCount === 0;
    const hasSelected = selectedCount > 0;

    let status = '○';

    if (allLocked) {
      status = '🔒';
    } else if (hasSelected) {
      status = '✓';
    }

    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.targetIndex = index;

    button.classList.toggle('is-locked', allLocked);
    button.classList.toggle('has-selected', hasSelected);

button.innerHTML = `
  <span class="builder-nav-title">
    <span>${getCategoryIcon(category)} ${category}</span>
    <span class="builder-nav-status">${status}</span>
  </span>

  <span class="builder-nav-selected">
    ${selectedCount} selected
  </span>

  <span class="builder-nav-meta">
    ${availableCount}/${totalCount} available
  </span>
`;

    button.addEventListener('click', () => {
  openAccordionCleanly(accordion, true);

      const y =
        accordion.getBoundingClientRect().top +
        window.pageYOffset -
        120;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });

      nav.querySelectorAll('button').forEach(btn => {
        btn.classList.remove('active');
      });

      button.classList.add('active');

      
    });

    nav.appendChild(button);
  });
}

function findAccordionForProduct(handle) {
  const activeGroup = document.querySelector(
    `.accordion-group[data-package="${currentPackageKey}"]`
  );

  if (!activeGroup || !handle) return null;

  // Product already mounted
  const mountedCard = activeGroup.querySelector(
    `.product-card[data-product-handle="${handle}"]`
  );

  if (mountedCard) {
    return mountedCard.closest('.accordion');
  }

  // Product still lazy-loaded
  return Array.from(activeGroup.querySelectorAll('.accordion')).find(accordion =>
    Array.isArray(accordion._builderLazyProducts) &&
    accordion._builderLazyProducts.some(product => product.handle === handle)
  );
}

function jumpToProduct(handle) {
  const accordion = findAccordionForProduct(handle);
  if (!accordion) return;

  accordion.classList.add('open');
  mountLazyAccordionProducts(accordion);

  setTimeout(() => {
    const targetCard = accordion.querySelector(
      `.product-card[data-product-handle="${handle}"]`
    );

    if (!targetCard) return;

    targetCard.scrollIntoView({
  behavior: 'smooth',
  block: 'center'
});

    targetCard.classList.add('sidebar-jump-highlight');

    setTimeout(() => {
      targetCard.classList.remove('sidebar-jump-highlight');
    }, 2000);
  }, 180);
}

function openAccordionCleanly(accordion, shouldScroll = true) {
  if (!accordion) return;

  if (window.innerWidth >= 769) {
    document.querySelectorAll('.accordion.open').forEach(openAccordion => {
  if (
    openAccordion !== accordion &&
    openAccordion.id !== 'pack-preview-accordion'
  ) {
    openAccordion.classList.remove('open');
  }
});
  }

  accordion.classList.add('open');
  mountLazyAccordionProducts(accordion);

  if (shouldScroll) {
    setTimeout(() => {
      const top =
        accordion.getBoundingClientRect().top +
        window.pageYOffset -
        220;

      window.scrollTo({
        top,
        behavior: 'auto'
      });
    }, 350);
  }
}

function setupLazyAccordions(scope = document) {
  scope.querySelectorAll('.accordion[data-pack-category]').forEach(accordion => {
    if (accordion.classList.contains('open')) return;
    if (accordion.dataset.lazyReady === 'true') return;

    const content = accordion.querySelector('.accordion-content');
    if (!content) return;

    const cards = Array.from(content.querySelectorAll('.product-card'));
    if (!cards.length) return;

    accordion._builderLazyProducts = cards.map(card => ({
      handle: card.dataset.productHandle,
      minQty: getProductMinQty(card.dataset.productHandle)
    }));

    const template = document.createElement('template');
    template.className = 'builder-lazy-template';
    template.innerHTML = content.innerHTML;

// Prevent images inside lazy templates loading until mounted
template.content.querySelectorAll('img').forEach(img => {
  const src = img.getAttribute('src');

  if (src) {
    img.setAttribute('data-src', src);
    img.removeAttribute('src');
  }

  img.loading = 'lazy';
  img.decoding = 'async';
});

    content.innerHTML = `
      <div class="builder-lazy-placeholder">
        Open this section to load products
      </div>
    `;

    content.appendChild(template);

    accordion.dataset.lazyReady = 'true';
    accordion.dataset.lazyMounted = 'false';
  });
}

function mountLazyAccordionProducts(accordion) {
  if (!accordion || accordion.dataset.lazyReady !== 'true') return;
  if (accordion.dataset.lazyMounted === 'true') return;

  const content = accordion.querySelector('.accordion-content');
  const template = content?.querySelector('template.builder-lazy-template');

  if (!content || !template) return;

  content.innerHTML = '';
  const clone = template.content.cloneNode(true);

clone.querySelectorAll('img[data-src]').forEach(img => {
  img.setAttribute('src', img.dataset.src);
});

content.appendChild(clone);

  accordion.dataset.lazyMounted = 'true';

  updatePackCategoryLabels(accordion);

  if (typeof initProductCarousels === 'function') {
    initProductCarousels(accordion);
  }

  accordion.querySelectorAll('.product-card').forEach(checkReady);

restorePackStudioSelections();
restoreAddedButtons();
updateProductAvailability();
buildBuilderNavigator();
updatePreview();

setTimeout(updateProductAvailability, 50);
}


function updateProductAvailability() {
  document.querySelectorAll('.product-card').forEach(card => {
    const handle = card.dataset.productHandle;
    if (!handle) return;

    const minQty = getProductMinQty(handle);
    const isAvailable = currentPackQty >= minQty;
    const isInPack = pack.some(item => item.handle === handle);
    const isLocked = !isAvailable && !isInPack;

    card.dataset.minQty = minQty;
    card.classList.toggle('product-locked', isLocked);

    let badge = card.querySelector('.locked-card-badge');

    if (isLocked && !badge) {
      badge = document.createElement('div');
badge.className = 'locked-card-badge';
      badge.innerHTML = `
  <span class="locked-card-badge-icon">🔒</span>
  <span class="locked-card-badge-text">Unlock at<br>${minQty}+ packs</span>
  <span class="locked-card-badge-hint">Click to update quantity</span>
  <button type="button" class="locked-card-badge-btn">
    <span>Hide locked</span>
    <span>products</span>
  </button>
`;
      card.appendChild(badge);
    }

    if (badge) {
      badge.title = `Unlock at ${minQty}+ packs. Click to hide locked products.`;
      badge.dataset.minQty = minQty;
    }

    if (!isLocked && badge) {
      badge.remove();
    }

    card.style.display =
      hideLockedProducts && isLocked
        ? 'none'
        : '';

    const btn = card.querySelector('.add-btn');
    if (!btn) return;

    btn.classList.remove('locked');

    if (isLocked) {
      btn.textContent = `Unlock at ${minQty}+`;
      btn.disabled = true;
      btn.classList.remove('ready');
      btn.classList.remove('added');
      btn.classList.add('locked');
      return;
    }

    if (isInPack) {
      btn.textContent = 'Update Pack';
      btn.disabled = false;
      btn.classList.add('ready');
      btn.classList.add('added');
      return;
    }

    btn.textContent = 'Add to Pack';
    checkReady(card);
  });
}

function savePackStudioSelections() {
  localStorage.setItem('packStudioSelections', JSON.stringify(packStudioSelections));
}

function restorePackStudioSelections() {
  document.querySelectorAll('.product-card').forEach(card => {
    const handle = card.dataset.productHandle;
    const packItem = pack.find(item => item.handle === handle);
    const saved = packItem || packStudioSelections[handle];

    if (!saved) return;

    if (saved.colour) {
      card.dataset.selectedColour = saved.colour;

      const colourDropdown = card.querySelectorAll('.custom-dropdown')[0];
      const colourLabel = colourDropdown?.querySelector('.selected-value span');
      const colourOption = colourDropdown?.querySelector(`.option[data-value="${saved.colour}"]`);

      if (colourLabel && colourOption) {
        colourLabel.textContent = colourOption.textContent;
      }

      if (colourOption?.dataset.image) {
        const img = card.querySelector('img');
        if (img) img.src = colourOption.dataset.image;
      }
    }

    if (saved.decoration) {
      card.dataset.selectedDecoration = saved.decoration;

      const decoDropdown = card.querySelectorAll('.custom-dropdown')[1];
      const decoLabel = decoDropdown?.querySelector('.selected-value span');
      const decoOption = decoDropdown?.querySelector(`.option[data-value="${saved.decoration}"]`);

      if (decoLabel && decoOption) {
        decoLabel.textContent = decoOption.textContent;
      }
    }
  });

  restoreAddedButtons();
  updateProductAvailability();
  updateSummary();
}

// ==================== CALCULATE DELIVERY DATE ====================
async function calculateDeliveryDate(leadTimeStr) {
  const leadDaysMatch = leadTimeStr.match(/\d+/);
  const leadDays = leadDaysMatch ? parseInt(leadDaysMatch[0]) : 10;

  const now = new Date();
  let orderDate = new Date(now);
  if (orderDate.getHours() >= 15) orderDate.setDate(orderDate.getDate() + 1);

  while (orderDate.getDay() === 0 || orderDate.getDay() === 6) {
    orderDate.setDate(orderDate.getDate() + 1);
  }

  let currentDate = new Date(orderDate);
  currentDate.setDate(currentDate.getDate() + 1);

  const cacheKey = 'ukBankHolidays';
  let ukHolidays = [];
  const cached = sessionStorage.getItem(cacheKey);
  if (cached) {
    ukHolidays = JSON.parse(cached).map(d => new Date(d));
  } else {
    try {
      const res = await fetch('https://www.gov.uk/bank-holidays.json');
      const data = await res.json();
      ukHolidays = data['england-and-wales'].events.map(e => new Date(e.date));
      sessionStorage.setItem(cacheKey, JSON.stringify(ukHolidays.map(d => d.toISOString())));
    } catch (e) {}
  }

  const holidaySet = new Set(ukHolidays.map(d => d.toDateString()));

  function isWorkingDay(date) {
    const day = date.getDay();
    if (day === 0 || day === 6) return false;
    if (holidaySet.has(date.toDateString())) return false;
    return true;
  }

  while (!isWorkingDay(currentDate)) currentDate.setDate(currentDate.getDate() + 1);

  let daysAdded = 0;
  while (daysAdded < leadDays) {
    currentDate.setDate(currentDate.getDate() + 1);
    if (isWorkingDay(currentDate)) daysAdded++;
  }

const dateStr = currentDate.toLocaleDateString('en-GB', {
  weekday: 'short',
  day: 'numeric',
  month: 'long'
});

// Remove comma after weekday (e.g. "Tue, 18 March" → "Tue 18 March")
return dateStr.replace(/,/, '');
}

function updateCompletedCategoryCircles() {
  const activeGroup = document.querySelector(
    `.accordion-group[data-package="${currentPackageKey}"]`
  );

  if (!activeGroup) return;

  activeGroup.querySelectorAll('.accordion[data-pack-category]').forEach(acc => {
    const circle = acc.querySelector('.num-circle');
    if (!circle) return;

    const mountedCards = Array.from(acc.querySelectorAll('.product-card'));

    const mountedHandles = mountedCards
      .map(card => card.dataset.productHandle)
      .filter(Boolean);

    const lazyHandles = Array.isArray(acc._builderLazyProducts)
      ? acc._builderLazyProducts.map(product => product.handle).filter(Boolean)
      : [];

    const allHandles = [...new Set([
      ...mountedHandles,
      ...lazyHandles
    ])];

    const categoryHasItem = allHandles.some(handle =>
      pack.some(item => item.handle === handle)
    );

    const wasCompleted = circle.classList.contains('completed');

    circle.classList.toggle('completed', categoryHasItem);

    if (categoryHasItem && !wasCompleted) {
      circle.classList.add('just-completed');

      setTimeout(() => {
        circle.classList.remove('just-completed');
      }, 500);
    }
  });
}

function updatePackImpact() {
  const titleEl = document.getElementById('pack-impact-title');
  const fillEl = document.getElementById('pack-impact-fill');
  const percentEl = document.getElementById('pack-impact-percent');
  const messageEl = document.getElementById('pack-impact-message');

  if (!titleEl || !fillEl || !percentEl || !messageEl) return;

  const activeGroup = document.querySelector(`.accordion-group[data-package="${currentPackageKey}"]`);
  if (!activeGroup) return;

  if (!pack.length) {
    fillEl.style.width = '0%';
    percentEl.textContent = '0';
    titleEl.textContent = 'Getting started';
    messageEl.textContent = 'Add a few useful products to start building your pack score.';
    return;
  }

  const categoryScores = {
    'Mugs': 9,
    'Bottles': 9,
    'Stationery': 8,
    'Tech': 8,
    'Bags': 8,
    'T-Shirts': 7,
    'Hoodies': 9,
    'Travel Mugs': 8,
    'Laptop Bags': 9,
    'Headwear': 6,
    'Outdoor': 6,
    'Events': 6,
    'Umbrellas': 6
  };

  const badgeBonuses = {
    recycled: 1,
    bestseller: 1,
    'best seller': 1,
    premium: 2,
    recommended: 1,
    fast: 1,
    'fast delivery': 1,
    madeinuk: 1,
    'made in uk': 1,
    uk: 1
  };

  let score = 0;
  const usedCategories = new Set();

  pack.forEach(item => {
    const card = activeGroup.querySelector(`.product-card[data-product-handle="${item.handle}"]`);
    const accordion = card?.closest('.accordion[data-pack-category]');
    const category = accordion?.dataset.packCategory || '';

    usedCategories.add(category);

    score += categoryScores[category] || 5;

    const badge = String(window.packProducts?.[item.handle]?.featured_badge || '')
      .trim()
      .toLowerCase();

    score += badgeBonuses[badge] || 0;
  });

  // Variety bonus: rewards balanced packs without forcing every section
  const varietyBonus = Math.min(20, usedCategories.size * 3);

  // Small bonus for richer packs, capped so people do not need loads of products
  const itemBonus = Math.min(10, pack.length * 1.5);

  const totalScore = score + varietyBonus + itemBonus;

  // 65 points feels like a strong, complete pack
  const percent = Math.min(100, Math.round((totalScore / 65) * 100));

  fillEl.style.width = percent + '%';
  percentEl.textContent = percent;

  let title = 'Getting started';
  let message = 'Add a few practical products to start building a stronger pack.';

  if (percent >= 90) {
    title = 'Outstanding pack';
    message = 'Excellent - this feels like a high-value, memorable pack with strong long-term use.';
  } else if (percent >= 75) {
    title = 'Excellent pack';
    message = 'A strong mix of useful products, lasting value and brand visibility.';
  } else if (percent >= 55) {
    title = 'Strong foundation';
    message = 'This is shaping up well - adding one more everyday-use item could make it even stronger.';
  } else if (percent >= 30) {
    title = 'Good start';
    message = 'You have a useful starting point. Add another practical item to improve the pack score.';
  }

  titleEl.textContent = title;
  messageEl.textContent = message;
}

function triggerPackAnimations(card = null) {

  // Product card glow
  if (card) {
    card.classList.remove('added-animate');

    void card.offsetWidth;

    card.classList.add('added-animate');
  }

  // Preview pulse
  const collage = document.querySelector('.collage-container');

  if (collage) {
    collage.classList.remove('preview-pulse');

    void collage.offsetWidth;

    collage.classList.add('preview-pulse');
  }

  // Sidebar pulse
  const bubble = document.querySelector('.per-person-bubble');

  if (bubble) {
    bubble.classList.remove('summary-pulse');

    void bubble.offsetWidth;

    bubble.classList.add('summary-pulse');
  }

  // Item count pop
  const count = document.getElementById('items-per-pack');

  if (count) {
    count.classList.remove('count-pop');

    void count.offsetWidth;

    count.classList.add('count-pop');
  }
}
// ==================== estimated value ====================

function calculatePackMarkup(baseCost) {
  if (baseCost < 144) return 50;
  if (baseCost < 350) return baseCost * 0.35;
  if (baseCost < 1000) return baseCost * 0.30;
  if (baseCost < 2500) return baseCost * 0.28;
  return baseCost * 0.25;
}

function getDecorationCostArrays(metafields) {
  const possibleKeys = [
    '1_colour_print',
    '2_colour_print',
    '3_colour_print',
    '4_colour_print',
    'full_colour_print',
    'embroidery_cost',
    'laser_engrave_costs'
  ];

  return possibleKeys
    .map(key => ({
      key,
      values: Array.isArray(metafields[key]) ? metafields[key].map(Number) : []
    }))
    .filter(item => item.values.length > 0);
}

const PERCEIVED_VALUE_MULTIPLIER = 1.6;

// ==================== estimated value ====================

function calculatePackMarkup(baseCost) {
  if (baseCost < 144) return 50;
  if (baseCost < 350) return baseCost * 0.35;
  if (baseCost < 1000) return baseCost * 0.30;
  if (baseCost < 2500) return baseCost * 0.28;
  return baseCost * 0.25;
}

function calculateEstimatedValueForItem(item) {
  const metafields = window.packProducts?.[item.handle];

  if (!metafields) {
    return 8;
  }

  const perceivedValue = Number(metafields.perceived_value);

  return perceivedValue > 0 ? perceivedValue : 8;
}


// ==================== UPDATE SUMMARY ====================
async function updateSummary() {
  let itemsCount = pack.length;
  let packRawCost = 0;
  let maxLeadDays = 0;
  let longestLeadTimeStr = "Not selected";
  let estimatedValuePerPerson = 0;

  pack.forEach(item => {
    const metafields = window.packProducts?.[item.handle];
    if (!metafields) return;

    estimatedValuePerPerson += calculateEstimatedValueForItem(item);
    const qtyBreaks = Array.isArray(metafields.quantity_breaks) ? metafields.quantity_breaks : [];
    const basePrices = Array.isArray(metafields.base_prices) ? metafields.base_prices : [];
    const carriage = Array.isArray(metafields.carriage) ? metafields.carriage : [];

    let qtyIndex = 0;
    for (let i = 0; i < qtyBreaks.length; i++) {
      if (Number(qtyBreaks[i]) <= currentPackQty) qtyIndex = i;
      else break;
    }

    const base = (qtyIndex < basePrices.length) ? parseFloat(basePrices[qtyIndex]) || 0 : 0;

    let addOn = 0;
let decoKey;

if (item.decoration.includes('colour')) {
  decoKey = item.decoration.replace('-', '_') + '_print';
} else if (item.decoration === 'embroidered') {
  decoKey = 'embroidery_cost';
} else if (item.decoration === 'laser-engraved') {
  decoKey = 'laser_engrave_costs';          // ← must match real metafield name
}

if (decoKey) {
  const decoArray = Array.isArray(metafields[decoKey]) ? metafields[decoKey] : [];
  addOn = (qtyIndex < decoArray.length) ? parseFloat(decoArray[qtyIndex]) || 0 : 0;
}

        let setupKey = '';
    if (item.decoration) {
      if (item.decoration.includes('colour')) {
        setupKey = item.decoration.replace('-', '_') + '_set_up_cost';
      } else if (item.decoration === 'embroidered') {
        setupKey = 'embroidery_set_up_cost';
      } else if (item.decoration === 'laser-engraved') {
        setupKey = 'laser_set_up_cost';
      }
    }
    const setup = (setupKey && metafields[setupKey] != null) ? parseFloat(metafields[setupKey]) || 0 : 0;

    const carriageCost = (qtyIndex < carriage.length) ? parseFloat(carriage[qtyIndex]) || 0 : 0;

    const productRawCost = (base + addOn) * currentPackQty + setup + carriageCost;
    packRawCost += productRawCost;


    const leadTimeRaw = metafields.lead_time || "Not selected";
    const leadTimeStr = Array.isArray(leadTimeRaw) ? leadTimeRaw[0] : leadTimeRaw;
    const leadDaysMatch = String(leadTimeStr).match(/\d+/);
    const leadDays = leadDaysMatch ? parseInt(leadDaysMatch[0]) : 0;

    if (leadDays > maxLeadDays) {
      maxLeadDays = leadDays;
      longestLeadTimeStr = leadTimeStr;
    }
  });

  let markup = 0;
  if (itemsCount > 0) {
    if (packRawCost < 144) markup = 50;
    else if (packRawCost < 350) markup = packRawCost * 0.35;
    else if (packRawCost < 1000) markup = packRawCost * 0.30;
    else if (packRawCost < 2500) markup = packRawCost * 0.28;
    else markup = packRawCost * 0.25;
  }

  const rawTotalExcVat = packRawCost + markup;

const perPersonExcVat = itemsCount > 0
  ? Math.round((rawTotalExcVat / currentPackQty) * 100) / 100
  : 0;

// Match main site: rounded unit price × quantity
const totalExcVat = perPersonExcVat * currentPackQty;

const vatAmount = totalExcVat * 0.2;
const grandTotal = totalExcVat + vatAmount;

  document.getElementById('pack-num-bubble').textContent = currentPackQty;
  document.getElementById('items-per-pack').textContent = itemsCount;
  document.getElementById('per-person').textContent = perPersonExcVat.toFixed(2);
  const estimatedValueEl = document.getElementById('estimated-value');

if (estimatedValueEl) {
  estimatedValueEl.textContent = estimatedValuePerPerson.toFixed(2);
}
  document.getElementById('total').textContent = totalExcVat.toFixed(2);
  document.getElementById('vat').textContent = vatAmount.toFixed(2);
  document.getElementById('grand-total').textContent = grandTotal.toFixed(2);

  const deliveryDisplay = document.getElementById('delivery-date');
  if (deliveryDisplay) {
    if (pack.length === 0) {
      deliveryDisplay.textContent = "No items selected";
    } else {
      deliveryDisplay.textContent = "Calculating...";
      calculateDeliveryDate(longestLeadTimeStr).then(dateStr => {
        deliveryDisplay.textContent = dateStr;
      }).catch(() => {
        deliveryDisplay.textContent = "Unavailable";
      });
    }
  }

  const packItems = document.getElementById('pack-items');
  if (packItems) {
    packItems.innerHTML = '';
    if (pack.length === 0) {
      packItems.innerHTML = '<p>No items in pack yet.</p>';
    } else {
      pack.forEach((item, index) => {

  const div = document.createElement('div');
  div.className = 'pack-item';

  const product = window.packProducts?.[item.handle];
  const minQty = Number(product?.quantity_breaks?.[0]) || 25;

  const title = item.handle
  .replace(/-/g, ' ')
  .replace(/\b\w/g, letter => letter.toUpperCase())
  .replace(/\bPromotional\b/gi, '')
  .replace(/\bBranded\b/gi, '')
  .replace(/\bDrinkware\b/gi, '')
  .replace(/\s+/g, ' ')
  .trim();

  div.innerHTML = `
    <div class="sidebar-item-click" data-product-handle="${item.handle}" style="cursor: pointer; display: flex; align-items: center; gap: 10px; flex: 1;">
      <img src="${item.imageSrc}" alt="${title}">
      <span>
        <strong>${title}</strong><br>
        ${item.colour} • ${formatDecoration(item.decoration)}
        ${product?.decoration_guidance ? ' ' + product.decoration_guidance : ''}

        ${minQty > 25
          ? `<br><small style="color:#888;">Minimum order: ${minQty} packs</small>`
          : ''}
      </span>
    </div>

    <button class="delete-btn" data-index="${index}">X</button>
  `;

  packItems.appendChild(div);

});

    }
  }

// Show/hide pack preview accordion
const previewAccordion = document.getElementById('pack-preview-accordion');

if (previewAccordion) {
  if (pack.length > 0) {
    previewAccordion.style.display = 'block';

    if (!previewAccordion.dataset.autoOpened) {
      previewAccordion.classList.add('open');
      previewAccordion.dataset.autoOpened = 'true';
    }
  } else {
    previewAccordion.style.display = 'none';
    previewAccordion.classList.remove('open');
    delete previewAccordion.dataset.autoOpened;
  }
}

  const collage = document.getElementById('collage');
  const emptyPreview = document.getElementById('preview-empty');

  if (collage && emptyPreview) {
    collage.innerHTML = '';
    if (pack.length === 0) {
      emptyPreview.style.display = 'block';
    } else {
      emptyPreview.style.display = 'none';
     pack.forEach(item => {
const img = document.createElement('img');
img.src = item.imageSrc;
img.alt = item.title;
img.loading = 'lazy';
img.dataset.productHandle = item.handle;
img.classList.add('preview-jump');
collage.appendChild(img);
});
    }
  }

  document.querySelectorAll('.product-card').forEach(card => {
    const unitPriceSpan = card.querySelector('.unit-price-value');
    if (!unitPriceSpan) return;

    const handle = card.dataset.productHandle;
    const metafields = window.packProducts?.[handle];
    if (!metafields || currentPackQty === 0) {
      unitPriceSpan.textContent = '0.00';
      return;
    }

    const qtyBreaks = Array.isArray(metafields.quantity_breaks) ? metafields.quantity_breaks : [];
    const basePrices = Array.isArray(metafields.base_prices) ? metafields.base_prices : [];
    const carriage = Array.isArray(metafields.carriage) ? metafields.carriage : [];

    let qtyIndex = 0;
    for (let i = 0; i < qtyBreaks.length; i++) {
      if (Number(qtyBreaks[i]) <= currentPackQty) qtyIndex = i;
      else break;
    }

    const base = (qtyIndex < basePrices.length) ? parseFloat(basePrices[qtyIndex]) || 0 : 0;

    let addOn = 0;
    let decoration = card.dataset.selectedDecoration || '';
    if (!decoration) {
      const decoDropdown = card.querySelectorAll('.custom-dropdown')[1];
      if (decoDropdown) {
        const firstOption = decoDropdown.querySelector('.dropdown-options .option[data-value]');
        if (firstOption) {
          decoration = firstOption.dataset.value;
        }
      }
    }

    if (decoration) {
      let decoKey;
      if (decoration.includes('colour')) {
        decoKey = decoration.replace('-', '_') + '_print';
      } else if (decoration === 'embroidered') {
        decoKey = 'embroidery_cost';
      } else if (decoration === 'laser-engraved') {
        decoKey = 'laser_engrave_costs';  // ← change only if your metafield name is different
      }
      if (decoKey) {
        const priceArray = Array.isArray(metafields[decoKey]) ? metafields[decoKey] : [];
        addOn = (qtyIndex < priceArray.length) ? parseFloat(priceArray[qtyIndex]) || 0 : 0;
      }
    }

    let setupKey = '';
    if (decoration) {
      if (decoration.includes('colour')) {
        setupKey = decoration.replace('-', '_') + '_set_up_cost';
      } else if (decoration === 'embroidered') {
        setupKey = 'embroidery_set_up_cost';
      } else if (decoration === 'laser-engraved') {
        setupKey = 'laser_set_up_cost';
      }
    }
    const setup = (setupKey && metafields[setupKey] != null) ? parseFloat(metafields[setupKey]) || 0 : 0;

    const carriageCost = (qtyIndex < carriage.length) ? parseFloat(carriage[qtyIndex]) || 0 : 0;

    const thisProductRawCost = (base + addOn) * currentPackQty + setup + carriageCost;

    let fullPackRawCost = packRawCost;
    if (!pack.some(item => item.handle === handle)) {
      fullPackRawCost += thisProductRawCost;
    }

    let fullMarkup = 0;
    if (fullPackRawCost < 144) fullMarkup = 50;
    else if (fullPackRawCost < 350) fullMarkup = fullPackRawCost * 0.35;
    else if (fullPackRawCost < 1000) fullMarkup = fullPackRawCost * 0.30;
    else if (fullPackRawCost < 2500) fullMarkup = fullPackRawCost * 0.28;
    else fullMarkup = fullPackRawCost * 0.25;

    const numItems = itemsCount + (pack.some(item => item.handle === handle) ? 0 : 1);
    const thisProductMarkupShare = fullMarkup / numItems;

    const thisProductTotal = thisProductRawCost + thisProductMarkupShare;
    const unitPrice = currentPackQty > 0 ? (thisProductTotal / currentPackQty).toFixed(2) : '0.00';

    unitPriceSpan.textContent = unitPrice;
  });
updatePackImpact();
updateCompletedCategoryCircles();
updateFlexibleTransferVisibility();
updateProductAvailability();
buildBuilderNavigator();
updatePackIdentityIntro();
}



function updateFlexibleTransferVisibility() {
  const box = document.getElementById('pack-flexible-transfer-box');

  if (!box) return;

  box.style.display = pack.length > 0 ? 'block' : 'none';
}

function formatDecoration(deco) {
  if (!deco) return '';
  return deco.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase());
}

// Save / Load
function savePack() {

  Builder.quantity = currentPackQty;
  Builder.selectedProducts = [...pack];

  localStorage.setItem('employeePackBuilder', JSON.stringify({
  pack: pack,
  quantity: currentPackQty,
  packageKey: 'builder',
  starterPack: currentStarterPack
}));

}

// Normal Pack Studio visits now start fresh.
// Shared/preloaded packs are handled by loadSharedPack().

// Quantity control
const qtyInput = document.getElementById('pack-qty');
const minusBtn = document.getElementById('pack-minus');
const plusBtn = document.getElementById('pack-plus');

function updateQuantityUI() {
  const pkg = packageConfigs[currentPackageKey];

  const mainQty = document.getElementById('pack-qty');
  const mainMinDisplay = document.getElementById('min-qty-display');

  const sideQty = document.getElementById('sidebar-pack-qty');
  const sideMinDisplay = document.getElementById('sidebar-min-qty-display');

  [mainQty, sideQty].forEach(input => {
    if (!input) return;

    input.min = getPackMinimumQty();
input.step = getStepForQty(currentPackQty);

    if (pkg.maxQty) {
      input.max = pkg.maxQty;
    } else {
      input.removeAttribute('max');
    }

    input.value = currentPackQty;
  });

  if (mainMinDisplay) mainMinDisplay.textContent = pkg.minQty;
  if (sideMinDisplay) sideMinDisplay.textContent = pkg.minQty;
}

if (qtyInput && minusBtn && plusBtn) {
  updateQuantityUI();

  minusBtn.addEventListener('click', () => {
    setPackQtyFromSidebar(
      getPreviousValidQty(currentPackQty)
    );
  });

  plusBtn.addEventListener('click', () => {
    const step = getStepForQty(currentPackQty);

    setPackQtyFromSidebar(
      currentPackQty + step
    );
  });

  qtyInput.addEventListener('blur', () => {
    setPackQtyFromSidebar(qtyInput.value);
  });

  qtyInput.addEventListener('change', () => {
    setPackQtyFromSidebar(qtyInput.value);
  });
}

// Sidebar quantity remote control
const sidebarQtyInput = document.getElementById('sidebar-pack-qty');
const sidebarMinusBtn = document.getElementById('sidebar-pack-minus');
const sidebarPlusBtn = document.getElementById('sidebar-pack-plus');
const sidebarMinQtyDisplay = document.getElementById('sidebar-min-qty-display');

function syncSidebarQtyUI() {
  updateQuantityUI();
}

function setPackQtyFromSidebar(value) {
  let val = parseInt(value) || currentPackQty;

  val = snapQtyToValidStep(val);

  currentPackQty = val;
  Builder.quantity = val;

  if (qtyInput) qtyInput.value = val;
  if (sidebarQtyInput) sidebarQtyInput.value = val;

  savePack();
  updateSummary();
  updateProductAvailability();
  syncSidebarQtyUI();
}

if (sidebarMinusBtn && sidebarPlusBtn && sidebarQtyInput) {
  syncSidebarQtyUI();

  sidebarMinusBtn.addEventListener('click', () => {
    const pkg = packageConfigs[currentPackageKey];
    setPackQtyFromSidebar(getPreviousValidQty(currentPackQty));
  });

  sidebarPlusBtn.addEventListener('click', () => {
    const pkg = packageConfigs[currentPackageKey];
    setPackQtyFromSidebar(currentPackQty + pkg.qtyStep);
  });

  sidebarQtyInput.addEventListener('blur', () => {
    setPackQtyFromSidebar(sidebarQtyInput.value);
  });
}

const floatingQtyUp = document.getElementById('floating-qty-up');
const floatingQtyDown = document.getElementById('floating-qty-down');

if (floatingQtyUp) {
  floatingQtyUp.addEventListener('click', () => {
    const pkg = packageConfigs[currentPackageKey];

    setPackQtyFromSidebar(
      currentPackQty + pkg.qtyStep
    );
  });
}

if (floatingQtyDown) {
  floatingQtyDown.addEventListener('click', () => {
    setPackQtyFromSidebar(
      getPreviousValidQty(currentPackQty)
    );
  });
}

setTimeout(() => {
  syncSidebarQtyUI();
}, 200);

// Nav
function buildPackageNav() {
  const nav = document.getElementById('package-nav');
  if (!nav) return;
  nav.innerHTML = '';

  Object.keys(packageConfigs).forEach(key => {
    const pkg = packageConfigs[key];
    const card = document.createElement('div');
    card.className = 'package-card' + (key === currentPackageKey ? ' active' : '');
    
    card.innerHTML = `
      <img src="${pkg.navImage || 'https://via.placeholder.com/180x120?text=' + encodeURIComponent(pkg.name)}" 
           alt="${pkg.name}" 
           loading="lazy">
      
      <!-- New Minimum Quantity Badge -->
      <div class="min-qty-badge">
        Minimum Qty ${pkg.minQty}
      </div>
      
      <span>${pkg.name}</span>
    `;
    
    card.addEventListener('click', () => {
  if (pkg.starterUrl) {
    if (pack.length > 0) {
      const confirmed = confirm(`Loading ${pkg.name} will replace your current pack. Continue?`);
      if (!confirmed) return;
    }

    window.location.href = pkg.starterUrl;
    return;
  }

  switchPackage(key);
});
    nav.appendChild(card);
  });
}

function showStarterState() {
    showBuilderState('builder', 'Pack Builder');
return;
  const hasPackUrl = new URLSearchParams(window.location.search).get('pack');
  if (hasPackUrl) return;

  document.body.classList.add('pack-starter-mode');

  const title = document.getElementById('current-package-title');
  const subtitle = document.getElementById('template-subtitle');
  const starterMessage = document.getElementById('starter-message');
  const packageDescription = document.getElementById('package-description');
  const qtyCard = document.getElementById('pack-qty-card');
  const accordionsContainer = document.getElementById('accordions-container');

  if (title) title.textContent = 'Choose a starter range above ↑';
  if (subtitle) subtitle.textContent = '';
  if (starterMessage) starterMessage.style.display = 'block';
  if (packageDescription) packageDescription.style.display = 'none';
  if (qtyCard) qtyCard.style.display = 'none';
  if (accordionsContainer) {
  accordionsContainer.classList.add('starter-hidden');
  accordionsContainer.style.display = 'none';
}
}

function runScriptsInside(container) {
  container.querySelectorAll('script').forEach(oldScript => {
    const newScript = document.createElement('script');

    Array.from(oldScript.attributes).forEach(attr => {
      newScript.setAttribute(attr.name, attr.value);
    });

    newScript.textContent = oldScript.textContent;
    oldScript.replaceWith(newScript);
  });
}

function updatePackCategoryLabels(scope = document) {
  scope.querySelectorAll('.accordion[data-pack-category]').forEach(accordion => {
    const label = accordion.querySelector('.pack-category-label');
    if (!label) return;

    label.textContent = accordion.dataset.packCategory || '';
  });
}

function mountPackageAccordions(packageKey) {
  const container = document.getElementById('accordions-container');
  const template = document.getElementById(`accordion-template-${packageKey}`);

  if (!container) {
    console.error('Missing accordions container');
    return;
  }

  if (!template) {
    console.error(`Missing accordion template: accordion-template-${packageKey}`);
    return;
  }

  if (container.dataset.loadedPackage === packageKey) return;

  container.innerHTML = '';

  const clone = template.content.cloneNode(true);
  container.appendChild(clone);

  runScriptsInside(container);

  container.dataset.loadedPackage = packageKey;

  updatePackCategoryLabels(container);

  if (typeof initProductCarousels === 'function') {
    initProductCarousels(container);
  }

  document.querySelectorAll('.product-card').forEach(checkReady);

  restorePackStudioSelections();
restoreAddedButtons();
resetUnaddedCardsToGrey();
setupLazyAccordions(container);
updateSummary();
buildBuilderNavigator();
}

function showBuilderState(packageKey, displayTitle) {
  document.body.classList.remove('pack-starter-mode');
  const pkg = packageConfigs[packageKey];
  if (!pkg) return;

  mountPackageAccordions(packageKey);

  const title = document.getElementById('current-package-title');
  const subtitle = document.getElementById('template-subtitle');
  const starterMessage = document.getElementById('starter-message');
  const packageDescription = document.getElementById('package-description');
  const qtyCard = document.getElementById('pack-qty-card');
  const accordionsContainer = document.getElementById('accordions-container');

  if (title) {
    title.textContent = `Building: ${displayTitle || pkg.name}`;
    title.classList.remove('pack-title-updated');
    void title.offsetWidth;
    title.classList.add('pack-title-updated');
  }

  if (subtitle) {
    subtitle.textContent = `${pkg.name} Range • Minimum ${pkg.minQty} Packs`;
  }

  if (starterMessage) starterMessage.style.display = 'none';
  if (packageDescription) packageDescription.style.display = 'block';
  if (qtyCard) qtyCard.style.display = 'flex';
  if (accordionsContainer) {
  accordionsContainer.classList.remove('starter-hidden');
  accordionsContainer.style.display = 'block';
}

  document.querySelectorAll('.accordion-group').forEach(group => {
    group.style.display = group.dataset.package === packageKey ? 'block' : 'none';
  });
}

function switchPackage(newKey) {
  const pkg = packageConfigs[newKey];
  if (!pkg) return;

  if (pack.length > 0) {
    const confirmed = confirm(`Switching to ${pkg.name} will clear your current pack. Continue?`);
    if (!confirmed) return;
  }

  currentPackageKey = newKey;
  currentPackQty = pkg.minQty;
  syncSidebarQtyUI();
  pack = [];
  packStudioSelections = {};

  localStorage.removeItem('employeePackBuilder');
  localStorage.removeItem('packStudioSelections');

  updateQuantityUI();
  showBuilderState(newKey, pkg.name);


  const descBox = document.getElementById('package-description');
  if (descBox) {
    descBox.classList.remove('package-description-updated');
    void descBox.offsetWidth;
    descBox.classList.add('package-description-updated');
  }

  function togglePreviewAccordion() {
  const previewAccordion = document.getElementById('pack-preview-accordion');

  if (!previewAccordion) return;

  if (pack.length > 0) {
    previewAccordion.style.display = 'block';
  } else {
    previewAccordion.style.display = 'none';
    previewAccordion.classList.remove('open');
    delete previewAccordion.dataset.autoOpened;
  }
}
buildPackageNav();
updateSummary();
restoreAddedButtons();
resetUnaddedCardsToGrey();
togglePreviewAccordion();
}
// Initial setup
// buildPackageNav();

const initialPackUrl = new URLSearchParams(window.location.search).get('pack');
const savedPackData = localStorage.getItem('employeePackBuilder');

if (initialPackUrl) {
  // loadSharedPack() will handle this on window load.
} else {
  if (savedPackData) {
    try {
      const data = JSON.parse(savedPackData);
      currentStarterPack = data.starterPack || null;

      pack = data.pack || [];
      currentPackQty = Number(data.quantity) || 25;
      currentPackageKey = 'builder';

      Builder.quantity = currentPackQty;
      Builder.selectedProducts = [...pack];

      if (qtyInput) qtyInput.value = currentPackQty;

      showBuilderState('builder', 'Pack Builder');
      updateQuantityUI();
      restorePackStudioSelections();
      updateSummary();
      restoreAddedButtons();
      resetUnaddedCardsToGrey();
      updatePreview();

    } catch (e) {
      console.error('Failed to auto-load saved pack:', e);
      pack = [];
      packStudioSelections = {};
      showStarterState();
buildStarterPackCarousel();
updateStarterPackHighlight();
    }
  } else {
    pack = [];
    packStudioSelections = {};

    updateSummary();
    restoreAddedButtons();
    resetUnaddedCardsToGrey();
    showStarterState();
  }
}



function togglePreviewAccordion() {
  const previewAccordion = document.getElementById('pack-preview-accordion');

  if (!previewAccordion) return;

  if (pack.length > 0) {
    previewAccordion.style.display = 'block';
  } else {
    previewAccordion.style.display = 'none';
    previewAccordion.classList.remove('open');
    previewHasAutoOpened = false;
  }
}



// Update preview when pack changes
function updatePreview() {
  const collage = document.getElementById('collage');
  const emptyPreview = document.getElementById('preview-empty');
  if (collage && emptyPreview) {
    collage.innerHTML = '';
    if (pack.length === 0) {
      emptyPreview.style.display = 'block';
    } else {
      emptyPreview.style.display = 'none';
      pack.forEach(item => {
        const img = document.createElement('img');
img.src = item.imageSrc;
img.alt = item.title;
img.loading = 'lazy';
img.dataset.productHandle = item.handle;
img.classList.add('preview-jump');
collage.appendChild(img);
      });
    }
  }
  togglePreviewAccordion();
}


function syncProductCardFromDetailPanel(panelActions) {
  if (!panelActions) return;

  const handle = panelActions.dataset.linkedProduct;

  const originalCard = handle
    ? document.querySelector(`.product-card[data-product-handle="${handle}"]`)
    : null;

  if (!originalCard) return;

  const panelDropdowns = panelActions.querySelectorAll('.custom-dropdown');
  const originalDropdowns = originalCard.querySelectorAll('.custom-dropdown');

  panelDropdowns.forEach((panelDropdown, index) => {
    const panelSelectedSpan = panelDropdown.querySelector('.selected-value span:first-child');
    const selectedText = panelSelectedSpan ? panelSelectedSpan.textContent.trim() : '';

    const selectedOption = Array.from(panelDropdown.querySelectorAll('.option')).find(option =>
      option.textContent.trim() === selectedText
    );

    if (!selectedOption || !originalDropdowns[index]) return;

    const value = selectedOption.dataset.value || '';
    const originalSelectedSpan = originalDropdowns[index].querySelector('.selected-value span:first-child');

    if (originalSelectedSpan) {
      originalSelectedSpan.textContent = selectedText;
    }

    if (!packStudioSelections[handle]) {
      packStudioSelections[handle] = {};
    }

    if (index === 0) {
      originalCard.dataset.selectedColour = value;
      packStudioSelections[handle].colour = value;

      const image = selectedOption.dataset.image || '';

      if (image) {
        const originalImg = originalCard.querySelector('img.product-image, img');

        if (originalImg) {
          originalImg.src = image;
          originalImg.setAttribute('src', image);
        }

        originalCard.dataset.selectedImage = image;
      }
    }

    if (index === 1) {
      originalCard.dataset.selectedDecoration = value;
      packStudioSelections[handle].decoration = value;
    }
  });

  savePackStudioSelections();
  checkReady(originalCard);
  updateSummary();
}

window.packProductGalleryCache = window.packProductGalleryCache || {};

function kbSizedShopifyImage(url, size = 'large') {
  if (!url) return '';

  const parts = url.split('?');
  const base = parts[0];
  const query = parts[1] ? `?${parts[1]}` : '';

  const cleanBase = base.replace(
    /_(pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d*)\.(jpg|jpeg|png|webp|gif)$/i,
    '.$2'
  );

  return cleanBase.replace(/\.(jpg|jpeg|png|webp|gif)$/i, `_${size}.$1`) + query;
}

async function getProductGalleryImages(handle, fallbackImage) {
  if (window.packProductGalleryCache[handle]) {
    return window.packProductGalleryCache[handle];
  }

  try {
    const response = await fetch(`/products/${handle}.js`);

    if (!response.ok) throw new Error('Product gallery fetch failed');

    const product = await response.json();

    const allImages = (product.images || [])
      .map(img => kbSizedShopifyImage(img, 'large'))
      .filter(Boolean);

    const variantImages = (product.variants || [])
      .map(variant => variant.featured_image && variant.featured_image.src)
      .filter(Boolean)
      .map(img => kbSizedShopifyImage(img, 'large'));

    const nonVariantImages = allImages.filter(img => !variantImages.includes(img));

    const orderedImages = [
      ...nonVariantImages,
      ...variantImages
    ];

    const cleanImages = [...new Set(orderedImages)];

    window.packProductGalleryCache[handle] =
      cleanImages.length ? cleanImages : [fallbackImage].filter(Boolean);

    return window.packProductGalleryCache[handle];
  } catch (error) {
    console.warn('Could not load product gallery:', handle, error);
    return [fallbackImage].filter(Boolean);
  }
}

// Call updatePreview after add/delete
document.addEventListener('click', async (e) => {

const sizeGuideBtn = safeClosest(e.target, '.pack-size-guide-btn');

if (sizeGuideBtn) {
  e.preventDefault();
  e.stopPropagation();

  const panel = sizeGuideBtn.closest('.product-detail-panel');
  const icon = panel
    ? document.querySelector(`.product-card[data-product-handle="${panel.dataset.productHandle}"] .info-icon`)
    : null;

  if (!icon?.dataset.sizeGuideContent) return;

  showPopup(`
    <button type="button" class="close-btn-svg" onclick="hidePopup()">
      ✕
    </button>

    <div class="size-guide-modal__content">
      ${icon.dataset.sizeGuideContent}
    </div>
  `);

  popup.style.position = 'fixed';
  popup.style.top = '50%';
  popup.style.left = '50%';
  popup.style.transform = 'translate(-50%, -50%)';
  popup.style.width = '90%';
  popup.style.maxWidth = '760px';
  popup.style.maxHeight = '85vh';
  popup.style.overflowY = 'auto';
  popup.style.padding = '28px';
  popup.style.zIndex = '99999';

  overlay.classList.add('visible');

  return;
}

  const viewDetailsBtn = safeClosest(e.target, '.view-details-btn');

if (viewDetailsBtn) {
  e.preventDefault();
  e.stopPropagation();

  const card = viewDetailsBtn.closest('.product-card');
  if (!card) return;

  const wrapper = card.closest('.product-grid-wrapper');
  if (!wrapper) return;

  const existingPanel = wrapper.querySelector('.product-detail-panel');
  const isSameOpen =
    existingPanel &&
    existingPanel.dataset.productHandle === card.dataset.productHandle;

  wrapper.querySelectorAll('.view-details-btn').forEach(btn => {
    btn.classList.remove('active');
    btn.textContent = 'View Details';
  });

  if (isSameOpen) {
  const closeBtn = existingPanel.querySelector('.product-detail-panel__close');

  if (closeBtn) {
    closeBtn.click();
  }

  return;
}

if (existingPanel) existingPanel.remove();

  const icon = card.querySelector('.info-icon');
  if (!icon) return;

  const title = card.querySelector('h4')?.textContent.trim() || 'Product details';
  const handle = card.dataset.productHandle;
  const imageSrc = card.querySelector('img')?.src || icon.dataset.image || '';
  const dropdowns = card.querySelectorAll('.custom-dropdown');
const colourDropdownHtml = dropdowns[0] ? dropdowns[0].outerHTML : '';
const decorationDropdownHtml = dropdowns[1] ? dropdowns[1].outerHTML : '';
const addButtonHtml = card.querySelector('.add-btn') ? card.querySelector('.add-btn').outerHTML : '';
viewDetailsBtn.textContent = 'Loading Details...';
viewDetailsBtn.disabled = true;

const cleanGalleryImages = await getProductGalleryImages(handle, imageSrc);

viewDetailsBtn.disabled = false;
  const description = icon.dataset.description || 'No description available.';
  const isInPack = pack.some(item => item.handle === handle);

  const specs = [
    { label: 'Min Order Quantity', value: icon.dataset.minQty },
    {
  label: 'Product Dimension',
  value: icon.dataset.sizeGuideContent
    ? `<button type="button" class="pack-size-guide-btn">View Size Chart</button>`
    : icon.dataset.dimensions
},
    { label: 'Capacity', value: icon.dataset.capacity },
    { label: 'Diameter', value: icon.dataset.diameter },
    { label: 'Branding Area', value: icon.dataset.printArea },
    { label: 'Branding Position', value: icon.dataset.brandingPosition },
    { label: 'Branding Technique', value: icon.dataset.brandingTechnique },
    { label: 'Material', value: icon.dataset.material },
    { label: 'Writing Ink Colour', value: icon.dataset.writingInkColour },
    { label: 'Leadtime', value: icon.dataset.leadtime }
  ].filter(spec =>
    spec.value &&
    spec.value !== 'N/A' &&
    String(spec.value).trim() !== ''
  );

  const specsHtml = specs.map(spec => `
    <div class="product-detail-spec">
      <span>${spec.label}</span>
      <strong>${spec.value}</strong>
    </div>
  `).join('');

  const panel = document.createElement('div');
  panel.className = 'product-detail-panel';
  panel.dataset.productHandle = handle;
  panel.dataset.returnHandle = handle;

  panel.innerHTML = `
    <button type="button" class="product-detail-panel__close">Close ✕</button>

    <div class="product-detail-panel__inner">
      <div>
  <div class="product-detail-gallery">
<img
  class="product-detail-panel__image"
  src="${imageSrc}"
  alt="${title}"
  decoding="async">

    ${cleanGalleryImages.length > 1 ? `
  <div class="product-detail-thumbs">
    ${cleanGalleryImages.slice(0, 8).map((img, index) => `
      <button type="button" class="product-detail-thumb ${index === 0 ? 'active' : ''}" data-image="${img}">
        <img
          src="${img}"
          alt="${title} image ${index + 1}"
          loading="lazy"
          decoding="async"
          width="72"
          height="72">
      </button>
    `).join('')}

    ${cleanGalleryImages.length > 8 ? `
      <div class="product-detail-thumb-more">
        <strong>More colours available</strong>
        <span>Use the colour dropdown</span>
      </div>
    ` : ''}
  </div>
` : ''}
  </div>

  <div class="product-detail-actions" data-linked-product="${handle}">
    <p class="product-detail-actions-title">Choose your options</p>

    ${colourDropdownHtml}
    ${decorationDropdownHtml}

    <div class="product-detail-status">
  ${isInPack ? '✓ Currently in your pack' : 'Not currently in your pack'}
</div>

${isInPack ? `
<button
  type="button"
  class="remove-from-pack-details-btn"
  data-product-handle="${handle}">
  ✕ Remove from your pack
</button>
` : ''}

${addButtonHtml}

    <p class="product-detail-actions-note">
      These options sync with the product card above.
    </p>
  </div>
</div>

      <div>

        <h3>${title}</h3>

        <div class="product-detail-description">
          ${description}
        </div>

        <div class="view-product-wrap">
    <a href="${icon.dataset.productUrl}"
   target="_blank"
   rel="noopener"
   title="Opens the full product page in a new tab"
   class="view-product-btn">
   View on Kaboom ↗
</a>
</div>

        <div class="product-detail-specs">
          ${specsHtml}
        </div>
      </div>
    </div>
  `;

if (window.innerWidth >= 769) {
  const grid = card.closest('.product-grid');
  const cards = Array.from(grid.querySelectorAll('.product-card'));
  const cardTop = card.offsetTop;

  let rowCards = cards.filter(item => item.offsetTop === cardTop);
  let lastCardInRow = rowCards[rowCards.length - 1];

  if (lastCardInRow) {
    lastCardInRow.insertAdjacentElement('afterend', panel);
  } else {
    card.insertAdjacentElement('afterend', panel);
  }
} else {
  wrapper.appendChild(panel);
}

  viewDetailsBtn.classList.add('active');
  viewDetailsBtn.textContent = 'Hide Details';

  setTimeout(() => {
    const y =
      panel.getBoundingClientRect().top +
      window.pageYOffset -
      235;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }, 80);

  return;
}

const detailCloseBtn = safeClosest(e.target, '.product-detail-panel__close');

if (detailCloseBtn) {
  e.preventDefault();
  e.stopPropagation();

  const panel = detailCloseBtn.closest('.product-detail-panel');
  const wrapper = detailCloseBtn.closest('.product-grid-wrapper');
  const handle = panel?.dataset.returnHandle || panel?.dataset.productHandle;

  const productCard = handle
    ? document.querySelector(`.product-card[data-product-handle="${handle}"]`)
    : null;

  const returnButton = productCard?.querySelector('.view-details-btn');

  if (panel) panel.remove();

  if (wrapper) {
    wrapper.querySelectorAll('.view-details-btn').forEach(btn => {
      btn.classList.remove('active');
      btn.textContent = 'View Details';
    });
  }

  if (returnButton) {
    setTimeout(() => {
      const offset = window.innerWidth <= 768 ? 620: 740;

      const y =
        returnButton.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }, 80);
  }

  return;
}

const detailThumb = safeClosest(e.target, '.product-detail-thumb');

if (detailThumb) {
  e.preventDefault();
  e.stopPropagation();

  const panel = detailThumb.closest('.product-detail-panel');
  const hero = panel?.querySelector('.product-detail-panel__image');

  if (hero && detailThumb.dataset.image) {
    hero.src = detailThumb.dataset.image;
  }

  panel.querySelectorAll('.product-detail-thumb').forEach(btn => {
    btn.classList.remove('active');
  });

  detailThumb.classList.add('active');

  return;
}

const detailPanelSelected = safeClosest(e.target, '.product-detail-actions .selected-value');

if (detailPanelSelected) {
  e.preventDefault();
  e.stopPropagation();

  const panelDropdown = detailPanelSelected.closest('.custom-dropdown');
  const panelOptions = panelDropdown?.querySelector('.dropdown-options');

  if (!panelOptions) return;

  const wasOpen = panelOptions.classList.contains('open');

  document.querySelectorAll('.product-detail-actions .dropdown-options.open').forEach(options => {
    if (options !== panelOptions) options.classList.remove('open');
  });

  panelOptions.classList.toggle('open', !wasOpen);

  return;
}

const detailPanelOption = safeClosest(e.target, '.product-detail-actions .option');

if (detailPanelOption) {
  e.preventDefault();
  e.stopPropagation();

  const panelActions = detailPanelOption.closest('.product-detail-actions');
  const panelDropdown = detailPanelOption.closest('.custom-dropdown');
  const handle = panelActions?.dataset.linkedProduct;

  const originalCard = handle
    ? document.querySelector(`.product-card[data-product-handle="${handle}"]`)
    : null;

  if (!panelActions || !panelDropdown || !originalCard) return;

  const dropdownIndex = Array.from(panelActions.querySelectorAll('.custom-dropdown')).indexOf(panelDropdown);

  const panelLabel = panelDropdown.querySelector('.selected-value span');
  if (panelLabel) {
    panelLabel.textContent = detailPanelOption.textContent;
  }

  panelDropdown.querySelector('.dropdown-options')?.classList.remove('open');

  const originalDropdown = originalCard.querySelectorAll('.custom-dropdown')[dropdownIndex];
  const optionValue = detailPanelOption.dataset.value || '';

const originalOption = Array.from(
  originalDropdown?.querySelectorAll('.option') || []
).find(option => option.dataset.value === optionValue);

  if (originalOption) {
  originalOption.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })
  );
}

  setTimeout(() => {
    const newImage = originalCard.querySelector('img')?.src;
    const hero = panelActions.closest('.product-detail-panel')?.querySelector('.product-detail-panel__image');

    if (hero && newImage && dropdownIndex === 0) {
      hero.src = newImage;
    }

    const panelAddBtn = panelActions.querySelector('.add-btn');
    const originalAddBtn = originalCard.querySelector('.add-btn');

    if (panelAddBtn && originalAddBtn) {
      panelAddBtn.textContent = originalAddBtn.textContent;
      panelAddBtn.className = originalAddBtn.className;
      panelAddBtn.disabled = originalAddBtn.disabled;
    }
  }, 80);

  return;
}

const detailPanelAddBtn = safeClosest(e.target, '.product-detail-actions .add-btn');

if (detailPanelAddBtn) {
  e.preventDefault();
  e.stopPropagation();

  const panelActions = detailPanelAddBtn.closest('.product-detail-actions');
  const handle = panelActions?.dataset.linkedProduct;

  const originalCard = handle
    ? document.querySelector(`.product-card[data-product-handle="${handle}"]`)
    : null;

  const originalBtn = originalCard?.querySelector('.add-btn');

  if (originalBtn && !originalBtn.disabled) {
  syncProductCardFromDetailPanel(panelActions);

  originalBtn.click();

  setTimeout(() => {
      const status = panelActions.querySelector('.product-detail-status');

      if (status) {
        status.textContent = '✓ Currently in your pack';
      }
      if (!panelActions.querySelector('.remove-from-pack-details-btn')) {
  const removeBtn = document.createElement('button');
  removeBtn.type = 'button';
  removeBtn.className = 'remove-from-pack-details-btn';
  removeBtn.dataset.productHandle = handle;
  removeBtn.textContent = '✕ Remove from your pack';

  status.insertAdjacentElement('afterend', removeBtn);
}

      detailPanelAddBtn.textContent = originalBtn.textContent;
      detailPanelAddBtn.className = originalBtn.className;
      detailPanelAddBtn.disabled = originalBtn.disabled;
    }, 100);
  }

  return;
}
const sidebarClick = safeClosest(e.target, '.sidebar-item-click');

if (sidebarClick) {
  e.preventDefault();
  e.stopPropagation();

  jumpToProduct(sidebarClick.dataset.productHandle);

  return;
}

const whyChooseBtn = safeClosest(e.target, '.why-choose-btn');

if (whyChooseBtn) {
  e.preventDefault();
  e.stopPropagation();

  const accordion = whyChooseBtn.closest('.accordion');
  const content = accordion?.querySelector('.wisdom-content');

  if (!content) return;

  const isOpen = content.style.display === 'block';

  content.style.display = isOpen ? 'none' : 'block';
  whyChooseBtn.innerHTML = isOpen ? '💡 Why Choose These?' : '✕ Close Why Choose';

  return;
}
const header = safeClosest(e.target, '.accordion-header');

if (header) {
  const accordion = header.parentElement;

  if (accordion.id === 'pack-preview-accordion') {
  accordion.classList.toggle('open');
  return;
}
  if (accordion.classList.contains('open')) {
    accordion.classList.remove('open');
  } else {
    openAccordionCleanly(accordion, true);
  }

  return;
}

  const selected = safeClosest(e.target, '.selected-value');

if (selected) {
  e.preventDefault();
  e.stopPropagation();

  const dropdown = selected.closest('.custom-dropdown');
  if (!dropdown) return;

  const options = dropdown.querySelector('.dropdown-options');
  if (!options) return;

  const wasOpen = options.classList.contains('open');

  document.querySelectorAll('.dropdown-options.open').forEach(o => {
    if (o !== options) o.classList.remove('open');
  });

  options.classList.toggle('open', !wasOpen);
  return;
}

  const option = safeClosest(e.target, '.option');
  if (option) {
    e.preventDefault();
e.stopPropagation();
    const dropdown = option.closest('.custom-dropdown');
    const selectedValue = dropdown.querySelector('.selected-value span');
    selectedValue.textContent = option.textContent;

    const card = dropdown.closest('.product-card');
    const handle = card.dataset.productHandle;

if (!packStudioSelections[handle]) {
  packStudioSelections[handle] = {};
}

if (dropdown.querySelector('.colour-select')) {
  card.dataset.selectedColour = option.dataset.value;
  packStudioSelections[handle].colour = option.dataset.value;

  if (option.dataset.image) {
    card.querySelector('img').src = option.dataset.image;
  }
} else {
  card.dataset.selectedDecoration = option.dataset.value;
  packStudioSelections[handle].decoration = option.dataset.value;
}

savePackStudioSelections();
updateSummary();
    dropdown.querySelector('.dropdown-options').classList.remove('open');
    checkReady(card);
    return;
  }

  if (!safeClosest(e.target, '.custom-dropdown')) {
    document.querySelectorAll('.dropdown-options.open').forEach(o => o.classList.remove('open'));
  }

  const addBtn = safeClosest(e.target, '.add-btn');

if (addBtn) {
  const card = addBtn.closest('.product-card');
  const handle = card.dataset.productHandle;
  const minQty = getProductMinQty(handle);

  if (card.classList.contains('product-locked')) {
  return;
}

  if (currentPackQty < minQty) {
    currentPackQty = minQty;
    Builder.quantity = currentPackQty;

    if (qtyInput) qtyInput.value = currentPackQty;
    if (sidebarQtyInput) sidebarQtyInput.value = currentPackQty;

    savePack();
    updateSummary();
    updateProductAvailability();
    syncSidebarQtyUI();
    buildBuilderNavigator();

    return;
  }

  if (addBtn.disabled) return;

  const title = card.querySelector('h4').textContent.trim();
  const colour = card.dataset.selectedColour;
  const decoration = card.dataset.selectedDecoration;
  const imageSrc = card.querySelector('img').src;

  const existingItem = pack.find(item => item.handle === handle);

  if (existingItem) {
    existingItem.title = title;
    existingItem.colour = colour;
    existingItem.decoration = decoration;
    existingItem.imageSrc = imageSrc;
  } else {
    pack.push({ handle, title, colour, decoration, imageSrc });
  }

  Builder.selectedProducts = [...pack];

const snappedQty = snapQtyToValidStep(currentPackQty);

if (snappedQty !== currentPackQty) {
  currentPackQty = snappedQty;
  Builder.quantity = currentPackQty;

  if (qtyInput) qtyInput.value = currentPackQty;
  if (sidebarQtyInput) sidebarQtyInput.value = currentPackQty;
}

  const starterBanner = document.getElementById('starter-pack-banner');

  if (starterBanner) {
    starterBanner.style.display = 'none';
  }

  savePack();
  updateSummary();
  restoreAddedButtons();

  triggerPackAnimations(card);

  addBtn.textContent = 'Update Pack';
  addBtn.classList.add('added');
  addBtn.classList.add('ready');
  addBtn.disabled = false;

  updatePreview();
  syncOpenDetailsPanelForProduct(handle);
}

  const deleteBtn = safeClosest(e.target, '.delete-btn');
  if (deleteBtn) {
    const index = parseInt(deleteBtn.dataset.index);
    if (!isNaN(index) && pack[index]) {
      const removedHandle = pack[index].handle;
      pack.splice(index, 1);
      Builder.selectedProducts = [...pack];
      const starterBanner = document.getElementById('starter-pack-banner');

if (starterBanner) {
  starterBanner.style.display = 'none';
}
      savePack();
      updateSummary();
      restoreAddedButtons();

      const card = document.querySelector(`.product-card[data-product-handle="${removedHandle}"]`);

if (card) {
  // Clear selected values
  delete card.dataset.selectedColour;
  delete card.dataset.selectedDecoration;

  // Clear saved localStorage dropdown choices for this product
  if (packStudioSelections && packStudioSelections[removedHandle]) {
    delete packStudioSelections[removedHandle];
    savePackStudioSelections();
  }

  // Reset dropdown display text
  const dropdowns = card.querySelectorAll('.custom-dropdown');

  const colourDropdown = dropdowns[0];
  const decoDropdown = dropdowns[1];

  const colourLabel = colourDropdown?.querySelector('.selected-value span');
  const decoLabel = decoDropdown?.querySelector('.selected-value span');

  if (colourLabel) colourLabel.textContent = 'Choose Colour';
  if (decoLabel) decoLabel.textContent = 'Choose Decoration';

  // Reset button to grey/inactive
  const btn = card.querySelector('.add-btn');

  if (btn) {
    btn.textContent = 'Add to Pack';
    btn.classList.remove('added');
    btn.classList.remove('ready');
    btn.disabled = true;
  }

  // Optional: restore original image if your product card stores one
  const img = card.querySelector('img');
  if (img && img.dataset.originalSrc) {
    img.src = img.dataset.originalSrc;
  }
}

      updatePreview(); // Update preview accordion state
    }
  }

  const previewClick = safeClosest(e.target, '.preview-jump');

if (previewClick) {
  e.preventDefault();
  e.stopPropagation();

  jumpToProduct(previewClick.dataset.productHandle);

  return;
}
  const question = safeClosest(e.target, '.faq-question');
  if (question) question.parentElement.classList.toggle('open');

  const icon = safeClosest(e.target, '.info-icon');
  if (icon) {
    e.preventDefault();

    const description = icon.dataset.description || 'No description available';
    const imageSrc = icon.dataset.image || '';

    let specsHtml = '<ul>';
    const specs = [
      { label: 'Min Order Quantity', value: icon.dataset.minQty },
      {
  label: 'Product Dimension',
  value: icon.dataset.sizeGuideContent
    ? `<button type="button" class="pack-size-guide-btn">View Size Chart</button>`
    : icon.dataset.dimensions
},
      { label: 'Capacity', value: icon.dataset.capacity },
      { label: 'Diameter', value: icon.dataset.diameter },
      { label: 'Branding Area', value: icon.dataset.printArea },
      { label: 'Branding Position', value: icon.dataset.brandingPosition },
      { label: 'Branding Technique', value: icon.dataset.brandingTechnique },
      { label: 'Material', value: icon.dataset.material },
      { label: 'Writing Ink Colour', value: icon.dataset.writingInkColour },
      { label: 'Leadtime', value: icon.dataset.leadtime }
    ];

    specs.forEach(spec => {
      if (spec.value && spec.value !== 'N/A' && spec.value.trim() !== '') {
        specsHtml += `<li><strong>${spec.label}:</strong> ${spec.value}</li>`;
      }
    });
    specsHtml += '</ul>';

    const html = `
      <img src="${imageSrc}" alt="Product image" style="max-width:100%; margin-bottom:12px; border-radius:8px;">
      <div class="description">${description}</div>
      <h4>Specification</h4>
      ${specsHtml}
    `;

    showPopup(html, icon);
  }

  const priceInfo = safeClosest(e.target, '.unit-price-info');
  if (priceInfo) {
    e.preventDefault();

    const card = priceInfo.closest('.product-card');
    if (!card) return;

    const title = card.querySelector('h4')?.textContent.trim() || 'this product';
    const price = card.querySelector('.unit-price-value')?.textContent || '0.00';

    let decoName = 'first available decoration';
    const selected = card.dataset.selectedDecoration;
    if (selected) {
      const dd = card.querySelectorAll('.custom-dropdown')[1];
      const opt = dd?.querySelector(`.option[data-value="${selected}"]`);
      decoName = opt ? opt.textContent.trim() : selected.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase());
    } else {
      const dd = card.querySelectorAll('.custom-dropdown')[1];
      const first = dd?.querySelector('.dropdown-options .option[data-value]');
      if (first) decoName = first.textContent.trim();
    }

    const html = `
      <div style="padding:8px 12px; text-align:center; font-size:14px; line-height:1.5;">
        This 'from' price (£${price}) is based on<br>
        <strong>${title}</strong><br>
        with <strong>${decoName}</strong> decoration
      </div>
    `;

    showPopup(html, priceInfo);
  }

  if (popup && popup.classList.contains('visible') &&
      !safeClosest(e.target, '.info-icon') &&
      !safeClosest(e.target, '.unit-price-info') &&
      !safeClosest(e.target, '#info-popup')) {
    hidePopup();
  }
});

function checkReady(card) {
  const handle = card.dataset.productHandle;
  const minQty = getProductMinQty(handle);

  const btn = card.querySelector('.add-btn');
  if (!btn) return;

  if (currentPackQty < minQty && !pack.some(item => item.handle === handle)) {
    btn.textContent = `Unlock at ${minQty}+ packs`;
    btn.disabled = true;
    btn.classList.remove('ready');
    btn.classList.remove('added');
    btn.classList.add('locked');
    return;
  }

  const colour = card.dataset.selectedColour || '';
  const deco = card.dataset.selectedDecoration || '';

  btn.classList.remove('locked');

  if (colour && deco) {
    btn.classList.add('ready');
    btn.disabled = false;
  } else {
    btn.classList.remove('ready');
    btn.disabled = true;
  }
}

document.querySelectorAll('.product-card').forEach(checkReady);

function restoreAddedButtons() {
  document.querySelectorAll('.product-card').forEach(card => {
    const handle = card.dataset.productHandle;
    const btn = card.querySelector('.add-btn');
    if (!btn || !handle) return;

    const minQty = getProductMinQty(handle);
    const isInPack = pack.some(item => item.handle === handle);
    const isLocked = currentPackQty < minQty && !isInPack;

    if (isLocked) {
      card.classList.add('product-locked');
      card.dataset.minQty = minQty;

      btn.textContent = `Unlock at ${minQty}+ packs`;
      btn.disabled = true;
      btn.classList.remove('ready');
      btn.classList.remove('added');
      btn.classList.add('locked');

      card.style.display = hideLockedProducts ? 'none' : '';
      return;
    }

    card.classList.remove('product-locked');
    card.style.display = '';

    btn.classList.remove('locked');

    let removeBtn = card.querySelector('.remove-from-pack-card-btn');

if (isInPack) {
  btn.textContent = 'Update Pack';
  btn.classList.add('added');
  btn.classList.add('ready');
  btn.disabled = false;

  if (!removeBtn) {
    removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'remove-from-pack-card-btn';
    removeBtn.textContent = 'Remove from pack';

    btn.insertAdjacentElement('afterend', removeBtn);
  }

} else {

  btn.textContent = 'Add to Pack';
  btn.classList.remove('added');

  if (removeBtn) {
    removeBtn.remove();
  }

  checkReady(card);
}
  });

  updateProductAvailability();
}

function removeProductFromPackByHandle(handle) {
  const index = pack.findIndex(item => item.handle === handle);
  if (index === -1) return;

  pack.splice(index, 1);
  Builder.selectedProducts = [...pack];

  if (packStudioSelections && packStudioSelections[handle]) {
    delete packStudioSelections[handle];
    savePackStudioSelections();
  }

  savePack();
  updateSummary();
  restoreAddedButtons();
  updatePreview();
  updateProductAvailability();
  buildBuilderNavigator();
  
  syncOpenDetailsPanelForProduct(handle);
}

function syncOpenDetailsPanelForProduct(handle) {
  const openPanel = document.querySelector(
    `.product-detail-panel[data-product-handle="${handle}"]`
  );

  if (!openPanel) return;

  const isInPack = pack.some(item => item.handle === handle);
  const status = openPanel.querySelector('.product-detail-status');
  const panelAddBtn = openPanel.querySelector('.add-btn');
  let removeBtn = openPanel.querySelector('.remove-from-pack-details-btn');

  if (status) {
    status.textContent = isInPack
      ? '✓ Currently in your pack'
      : 'Not currently in your pack';
  }

  if (panelAddBtn) {
    panelAddBtn.textContent = isInPack ? 'Update Pack' : 'Add to Pack';
    panelAddBtn.classList.toggle('added', isInPack);
    panelAddBtn.classList.toggle('ready', true);
    panelAddBtn.disabled = false;
  }

  if (isInPack && !removeBtn && status) {
    removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'remove-from-pack-details-btn';
    removeBtn.dataset.productHandle = handle;
    removeBtn.textContent = '✕ Remove from your pack';

    status.insertAdjacentElement('afterend', removeBtn);
  }

  if (!isInPack && removeBtn) {
    removeBtn.remove();
  }
}

function resetUnaddedCardsToGrey() {
  document.querySelectorAll('.product-card').forEach(card => {
    const handle = card.dataset.productHandle;
    const btn = card.querySelector('.add-btn');

    if (!btn) return;

    // Leave already-added products alone
    if (pack.some(item => item.handle === handle)) return;

    // Clear selected colour
    delete card.dataset.selectedColour;

    // Reset colour dropdown text
    const dropdowns = card.querySelectorAll('.custom-dropdown');
    const colourDropdown = dropdowns[0];
    const colourLabel = colourDropdown?.querySelector('.selected-value span');

    if (colourLabel) {
      colourLabel.textContent = 'Choose Colour';
    }

    // Reset button to grey
    btn.textContent = 'Add to Pack';
    btn.classList.remove('added');
    btn.classList.remove('ready');
    btn.disabled = true;
  });
}



// Carousel
function initProductCarousels(scope = document) {
  scope.querySelectorAll('.product-grid-wrapper').forEach(wrapper => {
    if (wrapper.dataset.carouselReady === 'true') return;

    const grid = wrapper.querySelector('.product-grid');
    const left = wrapper.querySelector('.carousel-arrow.left');
    const right = wrapper.querySelector('.carousel-arrow.right');

    if (!grid || !left || !right) return;

    function updateArrows() {
      const hasOverflow = grid.scrollWidth > grid.clientWidth + 10;
      wrapper.classList.toggle('has-overflow', hasOverflow);
      left.disabled = grid.scrollLeft <= 0;
      right.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 10;
    }

    left.addEventListener('click', () => {
      grid.scrollBy({ left: -240, behavior: 'smooth' });
    });

    right.addEventListener('click', () => {
      grid.scrollBy({ left: 240, behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    wrapper.dataset.carouselReady = 'true';

    setTimeout(updateArrows, 100);
    setTimeout(updateArrows, 500);
  });
}

initProductCarousels();

// ==================== INFO POPUP with SVG Close Button ====================
const popup = document.getElementById('info-popup');
const overlay = document.getElementById('info-popup-overlay');

function showPopup(html, triggerElement = null) {
  if (!popup || !overlay) return;

  popup.innerHTML = html;

  const isMobile = window.innerWidth <= 768;

  if (isMobile) {
    popup.style.position = 'fixed';
    popup.style.top = '50%';
    popup.style.left = '50%';
    popup.style.transform = 'translate(-50%, -50%)';
    popup.style.width = '90%';
    popup.style.maxWidth = '340px';
    popup.style.maxHeight = '85vh';
    popup.style.overflowY = 'auto';
    popup.style.borderRadius = '12px';
    popup.style.padding = '20px';

    // Add SVG Close Button
    const closeHTML = `
      <button class="close-btn-svg">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="11" fill="#dc3545"/>
          <path d="M8 8L16 16M16 8L8 16" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
      </button>
    `;
    popup.insertAdjacentHTML('afterbegin', closeHTML);

    // Attach click event to the new button
    const closeBtn = popup.querySelector('.close-btn-svg');
    if (closeBtn) closeBtn.addEventListener('click', hidePopup);

    overlay.classList.add('visible');
  } else {
    // Desktop behavior
    if (triggerElement) {
      const rect = triggerElement.getBoundingClientRect();
      popup.style.left = (rect.right + window.scrollX + 12) + 'px';
      popup.style.top = (rect.top + window.scrollY + (rect.height / 2) - 80) + 'px';
      popup.style.transform = 'none';
    }
    overlay.classList.remove('visible');
  }

  popup.classList.add('visible');
}

function hidePopup() {
  if (popup) {
    popup.classList.remove('visible');
    popup.innerHTML = '';
  }
  if (overlay) overlay.classList.remove('visible');
}

// Click outside to close (backup)
document.addEventListener('click', (e) => {
  if (popup && popup.classList.contains('visible')) {
    if (!popup.contains(e.target) && 
        !e.target.closest('.info-icon') && 
!e.target.closest('.unit-price-info') &&
!e.target.closest('.pack-size-guide-btn')) {
      hidePopup();
    }
  }
});

// Package nav arrows (show only when overflow)
const packageNavWrapper = document.querySelector('.package-nav-wrapper');
const packageNav = document.getElementById('package-nav');
const navLeft = document.getElementById('nav-arrow-left');
const navRight = document.getElementById('nav-arrow-right');

function updatePackageNavArrows() {
  if (!packageNav) return;
  const hasOverflow = packageNav.scrollWidth > packageNav.clientWidth + 10;
  packageNavWrapper?.classList.toggle('has-overflow', hasOverflow);
  
  if (hasOverflow) {
    navLeft.disabled = packageNav.scrollLeft <= 0;
    navRight.disabled = packageNav.scrollLeft + packageNav.clientWidth >= packageNav.scrollWidth - 10;
  }
}

if (navLeft && navRight && packageNav) {
  navLeft.addEventListener('click', () => {
    packageNav.scrollBy({ left: -240, behavior: 'smooth' });
  });
  
  navRight.addEventListener('click', () => {
    packageNav.scrollBy({ left: 240, behavior: 'smooth' });
  });
  
  packageNav.addEventListener('scroll', updatePackageNavArrows);
  window.addEventListener('resize', updatePackageNavArrows);
  
  // Initial check after nav builds
  setTimeout(updatePackageNavArrows, 300);
}

// Mobile "REVIEW PACKAGE" button - ROBUST FIXED VERSION
const reviewBtn = document.querySelector('.review-btn');

if (reviewBtn) {
  reviewBtn.addEventListener('click', () => {
    const sidebar = document.querySelector('.sidebar');
    if (!sidebar) return;

    // Open sidebar with strong mobile styles
    sidebar.classList.add('mobile-open');
    Object.assign(sidebar.style, {
      display: 'block',
      position: 'fixed',
      inset: '0',
      zIndex: '9999',
      background: '#a3c4c2',
      padding: '20px',
      borderRadius: '0',
      overflowY: 'auto',
      boxShadow: '0 0 0 100vmax rgba(0,0,0,0.5)'  // optional dark overlay feel
    });

    // Remove any previous close buttons to prevent duplicates
    document.querySelectorAll('#sidebar-close-btn').forEach(btn => btn.remove());

    // Create a FIXED close button (attached to body, not sidebar)
    const closeBtn = document.createElement('button');
    closeBtn.id = 'sidebar-close-btn';
    closeBtn.textContent = '✕ Close';
    closeBtn.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #dc3545;
      color: white;
      border: none;
      padding: 14px 22px;
      border-radius: 8px;
      cursor: pointer;
      font-weight: bold;
      font-size: 17px;
      box-shadow: 0 4px 15px rgba(0,0,0,0.4);
      z-index: 10000;
      pointer-events: auto;
    `;

    document.body.appendChild(closeBtn);

    // Close function
    function closeSidebar() {
      sidebar.classList.remove('mobile-open');
      sidebar.style.display = 'none';
      closeBtn.remove();
    }

    closeBtn.addEventListener('click', closeSidebar);

    // Optional: close when tapping outside the sidebar content
    sidebar.addEventListener('click', (e) => {
      if (e.target === sidebar) closeSidebar();
    });
  });
}
 

 
// Basin endpoint
const BASIN_ENDPOINT = 'https://usebasin.com/f/53bcf91d96ae';

// Imgbb API key
const IMGBB_API_KEY = '2d75eb571db440c72fc76ed61e30ab90';

async function uploadFileToImgbb(file) {
  const formData = new FormData();
  formData.append('key', IMGBB_API_KEY);
  formData.append('image', file);

  try {
    const response = await fetch('https://api.imgbb.com/1/upload', {
      method: 'POST',
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      return data.data.url;
    } else {
      console.error('Imgbb error:', data);
    }
  } catch (error) {
    console.error('Imgbb upload error:', error);
  }

  return null;
}

// Form handling
const packForm = document.getElementById('pack-studio-form');
const packSubmitBtn = document.getElementById('submit-pack');
const packUploadInput = document.getElementById('pack-attachments');
const packUploadStatus = document.getElementById('upload-status');

let packArtworkFiles = [];
let packArtworkUrls = [];

function updatePackArtworkFileList() {
  const list = document.getElementById('uploaded-files-list');

  if (packUploadStatus) {
    packUploadStatus.style.display = packArtworkFiles.length ? 'block' : 'none';
    packUploadStatus.textContent = `${packArtworkFiles.length} file(s) selected`;
  }

  if (list) {
    list.innerHTML = packArtworkFiles.map((file, index) => `
      <div style="display:flex; justify-content:space-between; gap:10px; padding:6px 0; border-bottom:1px solid rgba(0,0,0,0.08);">
        <span>${file.name}</span>
        <button type="button" data-remove-pack-file="${index}" style="border:none; background:none; color:#33404f; font-weight:700; cursor:pointer;">Remove</button>
      </div>
    `).join('');
  }
}

if (packUploadInput) {
  packUploadInput.addEventListener('change', () => {
    const newFiles = Array.from(packUploadInput.files || []);

    newFiles.forEach(file => {
      const alreadyAdded = packArtworkFiles.some(existing =>
        existing.name === file.name &&
        existing.size === file.size
      );

      if (!alreadyAdded) {
        packArtworkFiles.push(file);
      }
    });

    if (packArtworkFiles.length > 6) {
      packArtworkFiles = packArtworkFiles.slice(0, 6);
      alert('Please upload a maximum of 6 files.');
    }

    updatePackArtworkFileList();

    packUploadInput.value = '';
  });
}

document.addEventListener('click', function(e) {
  const removeBtn = e.target.closest('[data-remove-pack-file]');
  if (!removeBtn) return;

  const index = parseInt(removeBtn.dataset.removePackFile, 10);
  if (isNaN(index)) return;

  packArtworkFiles.splice(index, 1);
  updatePackArtworkFileList();
});

if (packForm && packSubmitBtn) {
  packForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    const name = document.getElementById('customer-name').value.trim();
    const email = document.getElementById('customer-email').value.trim();
    const confirmEmail = document.getElementById('confirm-email').value.trim();
    const mobile = document.getElementById('customer-mobile').value.trim() || 'Not provided';

    const noArtworkCheckbox = document.getElementById('no-artwork-yet-pack');
    const isNoArtworkMode = noArtworkCheckbox?.checked === true;

    if (pack.length === 0) {
      alert("Please add at least one product to your pack before submitting.");
      return;
    }

    if (!name || !email || !confirmEmail) {
      alert('Please fill in required fields (name + email).');
      return;
    }

    if (email !== confirmEmail) {
      alert('Emails do not match.');
      return;
    }

    if (!isNoArtworkMode && packArtworkFiles.length === 0) {
      alert('Please either:\n\n• Attach your logo/artwork files, OR\n• Tick "I\'m not ready to send artwork yet"');
      return;
    }

    packSubmitBtn.disabled = true;
    packSubmitBtn.textContent = 'Submitting...';

    packArtworkUrls = [];

    if (!isNoArtworkMode && packArtworkFiles.length > 0) {
      packUploadStatus.textContent = `Uploading ${packArtworkFiles.length} file(s)...`;
      packUploadStatus.style.display = 'block';

      for (let file of packArtworkFiles) {
        const url = await uploadFileToImgbb(file);
        if (url) {
          packArtworkUrls.push(url);
        }
      }

      if (packArtworkUrls.length === 0) {
        alert('Artwork upload failed. Please try again or tick "I’m not ready to send artwork yet".');
        packSubmitBtn.disabled = false;
        packSubmitBtn.textContent = 'Submit Pack for Proofs';
        return;
      }
    }

    const formData = new FormData();
    formData.append('01_Customer Name', name);
    formData.append('02_Customer Email', email);
    formData.append('03_Customer Number', mobile);

    const now = new Date();
    let orderDate = new Date(now);
    const hour = orderDate.getHours();

    if (hour >= 15) {
      orderDate.setDate(orderDate.getDate() + 1);
    }

    while (orderDate.getDay() === 0 || orderDate.getDay() === 6) {
      orderDate.setDate(orderDate.getDate() + 1);
    }

    const orderByDate = orderDate.toLocaleDateString('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });

    const deliveryCondition = `(if ordered and artwork approved before 3PM on ${orderByDate})`;

    let quoteSummary = `Multi-Quote Request (${pack.length} items)\n\n`;

    quoteSummary += `Quote 1:\n`;
    quoteSummary += `Quantity: ${currentPackQty}\n`;
    quoteSummary += `Colour: Kaboom\n`;
    quoteSummary += `Product: Pack Studio – ${packageConfigs[currentPackageKey]?.name || 'Custom Pack'}\n`;
    quoteSummary += `Decoration: Pack of ${pack.length} items\n`;
    quoteSummary += `Lead time: Not selected\n`;
    quoteSummary += `Estimated Delivery: ${document.getElementById('delivery-date')?.textContent || 'Not calculated'} ${deliveryCondition}\n`;
    quoteSummary += `Total exc VAT: £${document.getElementById('total')?.textContent || '0.00'}\n`;
    quoteSummary += `Total inc VAT: £${document.getElementById('grand-total')?.textContent || '0.00'}\n`;
    quoteSummary += `Text / Logo: Not provided\n`;

    if (isNoArtworkMode) {
      quoteSummary += `Artwork: Customer not ready yet - just wants PDF quote for the pack\n`;
    } else {
      quoteSummary += `Artwork URLs:\n${packArtworkUrls.length > 0 ? packArtworkUrls.join('\n') : 'No files uploaded'}\n`;
    }

    quoteSummary += `\n`;

    pack.forEach((item, index) => {
      quoteSummary += `Quote ${index + 2}:\n`;
      quoteSummary += `Quantity: ${currentPackQty}\n`;
      quoteSummary += `Colour: ${item.colour || 'Not selected'}\n`;
      quoteSummary += `Product: ${item.title}\n`;

      let decoLine = formatDecoration(item.decoration);
      const metafields = window.packProducts?.[item.handle];

      if (metafields?.decoration_guidance) {
        decoLine += ` ${metafields.decoration_guidance}`;
      }

      quoteSummary += `Decoration: ${decoLine}\n`;
      quoteSummary += `Lead time: Not selected\n`;
      quoteSummary += `Estimated Delivery: ${document.getElementById('delivery-date')?.textContent || 'Not calculated'} ${deliveryCondition}\n`;
      quoteSummary += `Total exc VAT: £0.00\n`;
      quoteSummary += `Total inc VAT: £0.00\n`;
      quoteSummary += `Text / Logo: Not provided\n`;
      quoteSummary += `Artwork URLs:\n${packArtworkUrls.length > 0 ? packArtworkUrls.join('\n') : 'No files uploaded'}\n\n`;
    });

    quoteSummary += `Note: URLs are direct downloads – click to save files.`;

    formData.append('14_Quote Details', quoteSummary);
    formData.append('15_Multi_Order_Saving', '0.00');
    formData.append('16_Combined_Total_Exc_VAT', `£${document.getElementById('grand-total')?.textContent || '0.00'}`);

    try {
      const response = await fetch(BASIN_ENDPOINT, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {

          if (typeof fbq !== 'undefined') {
    fbq('trackCustom', 'PackStudioSubmission');
  }
        if (isNoArtworkMode) {
          alert(`✅ Quote request received!\n\nWe'll email your Pack Studio PDF quote shortly.\n\nYou can send us your artwork later when you're ready.`);
        } else {
          alert(`✅ Pack submitted successfully!\n\nOur team will create proofs and email them to you shortly (usually within 24 hours).`);
        }

        pack = [];
        savePack();
        updatePackIdentityIntro();
        updateSummary();
        togglePreviewAccordion();
        restoreAddedButtons();

        packForm.reset();
        packArtworkUrls = [];
        packArtworkFiles = [];
        updatePackArtworkFileList();

        if (noArtworkCheckbox) noArtworkCheckbox.checked = false;

      } else {
        alert('Submission failed – please try again.');
      }
    } catch (error) {
      console.error('Basin submit error:', error);
      alert('Error submitting. Please try again.');
    } finally {
      packSubmitBtn.disabled = false;
      packSubmitBtn.textContent = 'Submit Pack for Proofs';
    }
  });
}
 

 
// ==================== SHARE / LOAD PACK LOGIC (TinyURL - Fixed Token Handling) ====================
const shareBox = document.getElementById('share-pack-box');
const shareBtn = document.getElementById('share-pack-btn');

function updateShareBoxVisibility() {
  if (shareBox) {
    shareBox.style.display = pack.length > 0 ? 'block' : 'none';
  }
}
updateShareBoxVisibility();

function updateFloatingStatus() {
  const qtySource = document.getElementById('pack-num-bubble');
  const itemsSource = document.getElementById('items-per-pack');
  const priceSource = document.getElementById('per-person');
  const totalSource = document.getElementById('total');

  const floatingQty = document.getElementById('floating-qty');
  const floatingItems = document.getElementById('floating-items');
  const floatingPrice = document.getElementById('floating-price');
  const floatingTotal = document.getElementById('floating-total');
  const tray = document.getElementById('floating-mini-tray');

  if (floatingQty && qtySource) {
    floatingQty.textContent = qtySource.textContent;
  }

  if (floatingItems && itemsSource) {
    floatingItems.textContent = itemsSource.textContent;
  }

  if (floatingPrice && priceSource) {
    floatingPrice.textContent = priceSource.textContent;
  }

  if (floatingTotal && totalSource) {
    floatingTotal.textContent = totalSource.textContent;
  }

  if (tray) {
    tray.innerHTML = '';

    pack.forEach(item => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'floating-mini-item';
      btn.dataset.productHandle = item.handle;
      btn.title = item.title || item.handle;

      btn.innerHTML = `
        <img src="${item.imageSrc}" alt="${item.title || item.handle}">
      `;

      tray.appendChild(btn);
    });
  }
  syncLockedToggleButton();
}

const floatingTopBtn = document.getElementById('floating-top');

if (floatingTopBtn) {
  floatingTopBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Scroll the main page to the top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // Scroll the independently scrolling sidebar to the top
    const sidebar = document.querySelector('.sidebar');

    if (sidebar) {
      sidebar.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }

    // Reset the horizontal section navigator, mainly for mobile
    const sectionNav = document.getElementById('builder-section-nav');

    if (sectionNav) {
      sectionNav.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    }

    // Close product accordions, but keep the pack preview open
    document.querySelectorAll('.accordion.open').forEach(accordion => {
      if (accordion.id !== 'pack-preview-accordion') {
        accordion.classList.remove('open');
      }
    });

    // Close the floating item tray
    const floatingBar = document.getElementById(
      'builder-floating-status'
    );

    floatingBar?.classList.remove('tray-open');

    const trayToggle = document.getElementById(
      'floating-tray-toggle'
    );

    if (trayToggle) {
      trayToggle.textContent = 'View items';
      trayToggle.setAttribute('aria-expanded', 'false');
    }
  });
}

const floatingTrayToggle = document.getElementById('floating-tray-toggle');

if (floatingTrayToggle) {
  floatingTrayToggle.addEventListener('click', function (e) {
    e.stopPropagation();

    const bar = document.getElementById('builder-floating-status');
    if (!bar) return;

    bar.classList.toggle('tray-open');

    floatingTrayToggle.textContent = bar.classList.contains('tray-open')
      ? 'Hide items'
      : 'View items';
  });
}

const lockedToggleBtn = document.getElementById('floating-locked-toggle');

if (lockedToggleBtn) {
  lockedToggleBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    hideLockedProducts = !hideLockedProducts;

    syncLockedToggleButton();
    updateProductAvailability();
    buildBuilderNavigator();
  });
}

document.addEventListener('click', function(e) {
  const badge = e.target.closest('.locked-card-badge');

  if (!badge || e.target.closest('.locked-card-badge-btn')) return;

  e.preventDefault();
  e.stopPropagation();

  const card = badge.closest('.product-card');
  if (!card) return;

  const minQty = Number(card.dataset.minQty) || getProductMinQty(card.dataset.productHandle);

  currentPackQty = minQty;
  Builder.quantity = currentPackQty;

  if (qtyInput) qtyInput.value = currentPackQty;
  if (sidebarQtyInput) sidebarQtyInput.value = currentPackQty;

  savePack();
  updateQuantityUI();
  updateSummary();
  updateProductAvailability();
  syncSidebarQtyUI();
  buildBuilderNavigator();
});

document.addEventListener('click', function(e) {
  const lockedBadgeBtn = e.target.closest('.locked-card-badge-btn');
  if (!lockedBadgeBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const accordion = lockedBadgeBtn.closest('.accordion');

  hideLockedProducts = true;

  syncLockedToggleButton();
  updateProductAvailability();
  buildBuilderNavigator();

  if (accordion) {
    const y =
      accordion.getBoundingClientRect().top +
      window.pageYOffset -
      180;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
});

function syncLockedToggleButton() {
  const btn = document.getElementById('floating-locked-toggle');
  if (!btn) return;

  btn.classList.toggle('active', hideLockedProducts);

  btn.innerHTML = hideLockedProducts
    ? '<span>🙈</span><span>Show locked</span>'
    : '<span>👁</span><span>Hide locked</span>';

  btn.title = hideLockedProducts
    ? 'Show locked products'
    : 'Hide locked products';
}

document.addEventListener('click', function (e) {

  const detailsRemoveBtn = e.target.closest('.remove-from-pack-details-btn');

if (detailsRemoveBtn) {
    e.preventDefault();
    e.stopPropagation();

    removeProductFromPackByHandle(
        detailsRemoveBtn.dataset.productHandle
    );

    return;
}
  const removeCardBtn = e.target.closest('.remove-from-pack-card-btn');

  if (removeCardBtn) {
    e.preventDefault();
    e.stopPropagation();

    const card = removeCardBtn.closest('.product-card');
    if (!card) return;

    removeProductFromPackByHandle(card.dataset.productHandle);
    return;
  }

  const miniItem = e.target.closest('.floating-mini-item');

  if (!miniItem) return;

  e.preventDefault();
  e.stopPropagation();

  if (miniItem.dataset.productHandle) {
    jumpToProduct(miniItem.dataset.productHandle);
  }
});

const originalUpdateSummary = updateSummary;
updateSummary = function() {
  originalUpdateSummary.apply(this, arguments);
  updateShareBoxVisibility();
  updateFloatingStatus();
};

// ====================== TINYURL TOKEN ======================
// Paste your token between the quotes below. Make sure there are NO extra spaces!
const TINYURL_API_TOKEN = "PyVl1wnkH9dR0dEKgi0Q1y5EmnUyOOml5E6VrYFcSNpBNCK150Sh32PsJcxs";
// ===========================================================

if (shareBtn) {
  shareBtn.addEventListener('click', async () => {
    if (pack.length === 0) {
      alert("Please add some products to your pack first!");
      return;
    }

    // Check if token is properly set
    if (!TINYURL_API_TOKEN || TINYURL_API_TOKEN === "paste-your-token-here" || TINYURL_API_TOKEN.length < 15) {
      alert("❌ TinyURL Token is not set correctly.\n\nPlease make sure you replaced 'paste-your-token-here' with your actual token.\n\nToken should be a long string like: 8f3k9... ");
      return;
    }

    // Build compressed URL
   const packData = {
  q: currentPackQty,
  p: currentPackageKey,
  s: packStudioSelections || {},
  i: pack.map(item => ({
    h: item.handle,
    c: item.colour || '',
    d: item.decoration || '',
    s: item.imageSrc || ''
  }))
};

    const compressed = LZString.compressToEncodedURIComponent(JSON.stringify(packData));
    const longUrl = `${window.location.origin}${window.location.pathname}?pack=${compressed}`;


    let finalUrl = longUrl;
    let success = false;

    try {
      const response = await fetch('https://api.tinyurl.com/create', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${TINYURL_API_TOKEN}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          url: longUrl,
          domain: "tiny.one"
        })
      });

      const data = await response.json();

      if (response.ok && data.data && data.data.tiny_url) {
        finalUrl = data.data.tiny_url;
        success = true;
        
      } else {
        console.error("TinyURL API returned error:", data);
      }
    } catch (err) {
      console.error("TinyURL request failed:", err);
    }

    const shareText = `Check out my Kaboom pack idea (${pack.length} items):\n\n${finalUrl}`;

    if (navigator.share) {
      navigator.share({
        title: 'My Kaboom Pack',
        text: `I built this pack with ${pack.length} items`,
        url: finalUrl
      }).catch(() => copyLink(shareText, finalUrl, success));
    } else {
      copyLink(shareText, finalUrl, success);
    }
  });
}

function copyLink(text, url, wasShortened) {
  navigator.clipboard.writeText(text).then(() => {
    if (wasShortened) {
      alert(`✅ Short link copied successfully!\n\n` +
            `Link: ${url}\n\n` +
            `You can now paste this into WhatsApp, email, or Messages.`);
    } else {
      alert('✅ Link copied (compressed version)');
    }
  }).catch(() => {
    alert('Here is your shareable link:\n\n' + url);
  });
}

function buildPackShareData() {
  return {
    q: currentPackQty,
    p: currentPackageKey,
    s: packStudioSelections || {},
    i: pack.map(item => ({
      h: item.handle,
      c: item.colour || '',
      d: item.decoration || '',
      s: item.imageSrc || ''
    }))
  };
}

function buildPackLongUrl() {
  const packData = buildPackShareData();

  const compressed = LZString.compressToEncodedURIComponent(
    JSON.stringify(packData)
  );

  return `${window.location.origin}${window.location.pathname}?pack=${compressed}`;
}

function exportStarterPack() {
  if (!pack || pack.length === 0) {
    alert('Please add some products to your pack first.');
    return;
  }

  const longUrl = buildPackLongUrl();

  const starterObject = `{
  id: '',
  title: '',
  subtitle: '',
  quantity: ${currentPackQty},
  navImage: '',
  starterUrl: '${longUrl}',
  items: []
}`;

  prompt('Copy this starter pack object:', starterObject);
}
// exportStarterPack() //


// ==================== LOAD COMPRESSED SHARED PACK ====================
function loadSharedPack() {
  suppressPackToast = true;
  const urlParams = new URLSearchParams(window.location.search);
  let packParam = urlParams.get('pack');

  const starterIdOnly = urlParams.get('starter');
const starterOnly = starterPacks.find(item => item.id === starterIdOnly);

if (!packParam && starterOnly?.starterUrl) {
  const starterUrl = new URL(starterOnly.starterUrl, window.location.origin);
  packParam = starterUrl.searchParams.get('pack');

  currentStarterPack = {
    id: starterOnly.id,
    title: starterOnly.title,
    subtitle: starterOnly.subtitle,
    quantity: starterOnly.quantity || 25,
    originalHandles: []
  };

  updateStarterPackHighlight();

  window.loadedTemplateName = starterOnly.title;
}

const templateName = urlParams.get('template') || '';
const starterId = urlParams.get('starter') || '';
const starterFromUrl = starterPacks.find(item => item.id === starterId);

window.loadedTemplateName = starterFromUrl ? starterFromUrl.title : templateName;

  // If a starter/template pack is loading, preserve the user's previous saved pack
  if (templateName) {
  const existingSavedPack = localStorage.getItem('employeePackBuilder');
  const existingSelections = localStorage.getItem('packStudioSelections');

  if (existingSavedPack) {
    localStorage.setItem('previousEmployeePackBuilder', existingSavedPack);

    if (existingSelections) {
      localStorage.setItem('previousPackStudioSelections', existingSelections);
    } else {
      localStorage.removeItem('previousPackStudioSelections');
    }
  }
}

  if (!packParam) return;

  try {
    const decompressed = LZString.decompressFromEncodedURIComponent(packParam);
    if (!decompressed) throw new Error("Decompression failed");

    const decoded = JSON.parse(decompressed);

    currentPackQty = decoded.q || 50;
    currentPackageKey = 'builder';
    Builder.quantity = currentPackQty;
  packStudioSelections = decoded.s || {};
savePackStudioSelections();

const displayTitle = window.loadedTemplateName || packageConfigs[currentPackageKey].name;

showBuilderState(currentPackageKey, displayTitle);

const starterBanner = document.getElementById('starter-pack-banner');

if (starterBanner) {
  if (window.loadedTemplateName) {
    const hasPreviousPack = localStorage.getItem('previousEmployeePackBuilder');

    let previousItemCount = 0;

try {
  const previousPackData = JSON.parse(hasPreviousPack || '{}');
  previousItemCount = previousPackData.pack ? previousPackData.pack.length : 0;
} catch (e) {}

    starterBanner.innerHTML = `
      <h4>✅ ${window.loadedTemplateName} loaded</h4>
      <p>
        We’ve pre-filled this pack for you. Click any item below to change products,
        colours or decoration.
      </p>

      ${
        hasPreviousPack
          ? `
            <button type="button" id="restore-previous-pack" class="continue-saved-pack-btn" style="margin-top:12px;">
              Continue Previous Pack Build
${previousItemCount > 0 ? `<span>(${previousItemCount} items selected)</span>` : ''}
            </button>
          `
          : ''
      }
    `;

    starterBanner.style.display = 'block';
  } else {
    starterBanner.style.display = 'none';
  }
}



const accordionsContainer = document.getElementById('accordions-container');
if (accordionsContainer) {
  accordionsContainer.classList.remove('starter-hidden');
  accordionsContainer.style.display = 'block';
}

document.querySelectorAll('.accordion-group').forEach(group => {
  group.style.display =
    group.dataset.package === currentPackageKey ? 'block' : 'none';
});    const subtitle = document.getElementById('template-subtitle');

if (subtitle) {
  subtitle.textContent =
    `${packageConfigs[currentPackageKey].name} Range • Minimum ${packageConfigs[currentPackageKey].minQty} Packs`;
}

    updateQuantityUI();

    pack = (decoded.i || []).map(item => ({
      handle: item.h,
      title: '',
      colour: item.c || '',
      decoration: item.d || '',
      imageSrc: item.s || ''
    }));


    if (starterFromUrl) {
  currentStarterPack = {
    id: starterFromUrl.id,
    title: starterFromUrl.title,
    subtitle: starterFromUrl.subtitle,
    quantity: starterFromUrl.quantity || currentPackQty,
    originalHandles: pack.map(item => item.handle)
  };
} else if (templateName) {
  currentStarterPack = {
    id: '',
    title: templateName,
    subtitle: 'Customise your selected pack below.',
    quantity: currentPackQty,
    originalHandles: pack.map(item => item.handle)
  };
}


    Builder.selectedProducts = [...pack];
    

    if (qtyInput) qtyInput.value = currentPackQty;

buildPackageNav();
restorePackStudioSelections();
updateSummary();
updatePackIdentityIntro();
restoreAddedButtons();

function finishSharedPackLoad() {
  restorePackStudioSelections();

  document.querySelectorAll('.product-card').forEach(card => {
    const handle = card.dataset.productHandle;
    const found = pack.find(p => p.handle === handle);

    if (found && card.querySelector('h4')) {
      found.title = card.querySelector('h4').textContent.trim();
    }
  });

  savePack();
  cleanPackStudioUrl();

  updateSummary();
  restoreAddedButtons();
  updatePreview();
  updatePackIdentityIntro();
}

setTimeout(finishSharedPackLoad, 300);
setTimeout(finishSharedPackLoad, 900);
setTimeout(finishSharedPackLoad, 1600);

setTimeout(() => {
  suppressPackToast = false;
}, 2500);



  } catch (err) {
    console.error('Failed to load shared pack:', err);
  }
}

window.addEventListener('load', function () {
  buildStarterPackCarousel();
  loadSharedPack();

  setTimeout(updateFloatingStatus, 500);
  setTimeout(updateFloatingStatus, 1200);

  const hasPackUrl = new URLSearchParams(window.location.search).get('pack');

  setTimeout(() => {
    if (!hasPackUrl) {
      showSavedPackPrompt();
    }
  }, 400);
});


document.addEventListener('click', function(e) {
  const restoreBtn = e.target.closest('#restore-previous-pack');
  if (!restoreBtn) return;

  e.preventDefault();

  const previousPack = localStorage.getItem('previousEmployeePackBuilder');
  const previousSelections = localStorage.getItem('previousPackStudioSelections');

  if (!previousPack) return;

  try {
    const data = JSON.parse(previousPack);

    pack = data.pack || [];
    currentPackQty = Number(data.quantity) || 25;
    currentStarterPack = data.starterPack || null;
    updateStarterPackHighlight();
updatePackIdentityIntro();
    currentPackageKey = 'builder';
    Builder.quantity = currentPackQty;
Builder.selectedProducts = [...pack];

    if (previousSelections) {
      packStudioSelections = JSON.parse(previousSelections);
      localStorage.setItem('packStudioSelections', previousSelections);
    } else {
      packStudioSelections = {};
      localStorage.removeItem('packStudioSelections');
    }

    localStorage.setItem('employeePackBuilder', previousPack);

    localStorage.removeItem('previousEmployeePackBuilder');
    localStorage.removeItem('previousPackStudioSelections');

    window.loadedTemplateName = '';

    updateQuantityUI();
    showBuilderState(currentPackageKey, packageConfigs[currentPackageKey]?.name);

    buildPackageNav();
    restorePackStudioSelections();
    updateSummary();
    restoreAddedButtons();
    resetUnaddedCardsToGrey();
    togglePreviewAccordion();

    const sidebarQty = document.getElementById('sidebar-pack-qty');
const mainQty = document.getElementById('pack-qty');

if (mainQty) mainQty.value = currentPackQty;
if (sidebarQty) sidebarQty.value = currentPackQty;

syncSidebarQtyUI();

    const starterBanner = document.getElementById('starter-pack-banner');
    if (starterBanner) starterBanner.style.display = 'none';

    const savedPackMessage = document.getElementById('saved-pack-message');
if (savedPackMessage) savedPackMessage.style.display = 'none';

  } catch (err) {
    console.error('Failed to restore previous pack:', err);
  }
});


 

 
document.querySelectorAll('.faq-link').forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();

    const targetId = link.getAttribute('href');
    const target = document.querySelector(targetId);

    if (!target) return;

    // Open FAQ first
    if (!target.classList.contains('open')) {
      target.classList.add('open');
    }

    // Wait for accordion expansion
    setTimeout(() => {

      const offset = 120; // adjust this number
      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

    }, 150);
  });
});
 
 

 

 

 
// ====================== NO ARTWORK YET - PACK STUDIO ======================
function setupPackNoArtworkToggle() {
  const checkbox = document.getElementById('no-artwork-yet-pack');
  const fileInput = document.getElementById('pack-attachments');
  const uploadStatus = document.getElementById('upload-status');
  const uploadedList = document.getElementById('uploaded-files-list');
  
  // New: Target the label and small text
  const artworkLabel = document.querySelector('label[for="pack-attachments"]');
  const fileHelpText = document.querySelector('small[style*="color: #666"]'); // targets the "You can select up to 6 files" text

  if (!checkbox) return;

  function toggleNoArtworkMode() {
    const isChecked = checkbox.checked;

    if (isChecked) {
      // Hide everything related to file upload
      if (fileInput) fileInput.style.display = 'none';
      if (uploadStatus) uploadStatus.style.display = 'none';
      if (uploadedList) uploadedList.style.display = 'none';
      if (artworkLabel) artworkLabel.style.display = 'none';
      if (fileHelpText) fileHelpText.style.display = 'none';

      packArtworkUrls = []; // clear any uploaded files
    } else {
      // Show everything again
      if (fileInput) fileInput.style.display = '';
      if (uploadStatus) uploadStatus.style.display = '';
      if (uploadedList) uploadedList.style.display = '';
      if (artworkLabel) artworkLabel.style.display = '';
      if (fileHelpText) fileHelpText.style.display = '';
    }
  }

  checkbox.addEventListener('change', toggleNoArtworkMode);
}

// Initialise it
document.addEventListener('DOMContentLoaded', () => {
  setupPackNoArtworkToggle();
});

 

 
document.getElementById('transfer-to-flexible-builder')?.addEventListener('click', () => {
  if (!pack || pack.length === 0) {
    alert('Please add at least one product to your pack first.');
    return;
  }

const activePackage = packageConfigs[currentPackageKey] || {};

const transferData = {
  source: 'Pack Studio',
  packageKey: currentPackageKey,
  packageName: activePackage.name || 'Custom Pack',
  originalPackQuantity: currentPackQty,
  packageMinQty: getPackMinimumQty(),
  packageQtyStep: activePackage.qtyStep || 1,
  packageMaxQty: activePackage.maxQty || null,
    items: pack.map(item => ({
      handle: item.handle,
      title: item.title,
      colour: item.colour || '',
      decoration: item.decoration || '',
      imageSrc: item.imageSrc || '',
      quantity: currentPackQty,
      minQty: getProductMinQty(item.handle),
      qtyIncrement: getProductQtyIncrement(item.handle)
    }))
  };

  localStorage.setItem('kaboomFlexiblePackTransfer', JSON.stringify(transferData));

  window.location.href = '/pages/flexible-pack-builder';
});

document.getElementById('download-pack-pdf')?.addEventListener('click', function(e) {
  e.stopPropagation();
});


 
async function imageToDataUrl(url) {
  try {
    const response = await fetch(url, { mode: 'cors' });
    const blob = await response.blob();

    return await new Promise(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    console.warn('PDF image failed:', url, e);
    return null;
  }
}

async function addLogoToPdf(pdf, x, y, w) {
  const logoUrl = 'https://cdn.shopify.com/s/files/1/0979/0236/2999/files/kaboom-branding-logo.png?v=1777220229';
  const logoData = await imageToDataUrl(logoUrl);

  if (!logoData) return;

  try {
    pdf.addImage(logoData, 'PNG', x, y, w, 0, undefined, 'FAST');
  } catch (e) {
    console.warn('Logo skipped', e);
  }
}

function safePdfText(value) {
  return String(value || '').replace(/[^\x20-\x7E£–—]/g, '');
}

function loadJsPDF() {
  return new Promise((resolve, reject) => {
    if (window.jspdf && window.jspdf.jsPDF) {
      resolve(window.jspdf.jsPDF);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
    script.onload = () => resolve(window.jspdf.jsPDF);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

document.getElementById('download-pack-pdf')?.addEventListener('click', async () => {
  if (!pack || pack.length === 0) {
    alert('Please add at least one product to your pack first.');
    return;
  }

  const btn = document.getElementById('download-pack-pdf');
  const originalText = btn.textContent;

  btn.disabled = true;
  btn.textContent = 'Creating PDF...';
  const jsPDF = await loadJsPDF();

try {
  const jsPDF = await loadJsPDF();
  const pdf = new jsPDF('p', 'mm', 'a4');

    const pageWidth = 210;
    const pageHeight = 297;
    const margin = 14;

    const packageName = safePdfText(packageConfigs[currentPackageKey]?.name || 'Custom Pack');
    const delivery = safePdfText(document.getElementById('delivery-date')?.textContent || 'Not calculated');
    const perPerson = safePdfText(document.getElementById('per-person')?.textContent || '0.00');
    const total = safePdfText(document.getElementById('total')?.textContent || '0.00');
    const grandTotal = safePdfText(document.getElementById('grand-total')?.textContent || '0.00');
    const impactTitle = safePdfText(document.getElementById('pack-impact-title')?.textContent || 'Pack concept');
    const impactPercent = Number(document.getElementById('pack-impact-percent')?.textContent || '0');

    // =========================
    // PAGE 1 — SUMMARY
    // =========================

    pdf.setFillColor(136, 173, 185);
    pdf.rect(0, 0, pageWidth, 36, 'F');

    await addLogoToPdf(pdf, margin, 7, 48);

    pdf.setTextColor(255, 255, 255);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(19);
    pdf.text(`Your ${packageName} Pack`, 72, 17);

    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(8.5);
    pdf.text('Created with Kaboom Pack Studio', 72, 26);

    pdf.setTextColor(51, 64, 79);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(19);
    pdf.text(packageName, margin, 52);

    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(9.5);
    pdf.setTextColor(75, 75, 75);
    pdf.text(
  `A visual concept summary designed to help you share, review and refine your ${packageName} pack before requesting your official quote.`,
  margin,
  62,
  { maxWidth: 182 }
);

    // Summary cards
    const cardY = 82;
    const cardW = 50;
    const cardH = 23;
    const cardGap = 7;

    const summaryCards = [
      { label: 'Quantity', value: `${currentPackQty}` },
      { label: 'Products', value: `${pack.length}` },
      { label: 'Per Person', value: `£${perPerson}` }
    ];

    summaryCards.forEach((card, i) => {
      const x = margin + i * (cardW + cardGap);

      pdf.setFillColor(240, 249, 251);
      pdf.roundedRect(x, cardY, cardW, cardH, 5, 5, 'F');

      pdf.setTextColor(101, 122, 137);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6.8);
      pdf.text(card.label.toUpperCase(), x + 5, cardY + 8);

      pdf.setTextColor(51, 64, 79);
      pdf.setFontSize(17);
      pdf.text(card.value, x + 5, cardY + 17);
    });

    // Inline totals
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(9.5);
    pdf.setTextColor(101, 122, 137);
    pdf.text(
      `Estimated delivery: ${delivery}   |   Total exc VAT: £${total}   |   Total inc VAT: £${grandTotal}`,
      margin,
      118
    );

    // =========================
    // PACK BALANCE
    // =========================

    pdf.setFillColor(238, 246, 245);
    pdf.roundedRect(margin, 132, 182, 38, 6, 6, 'F');

    pdf.setFontSize(17);
    pdf.text(impactTitle, margin + 8, 142);

    pdf.setTextColor(51, 64, 79);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(13);
    pdf.text('Pack Balance', margin + 8, 153);

    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(9);
    pdf.setTextColor(101, 122, 137);
    const impactMessage =
  document.getElementById('pack-impact-message')?.textContent || '';

pdf.text(`${impactPercent}% complete -`, margin + 8, 162);

if (impactMessage) {
  pdf.text(
    impactMessage,
    margin + 31,
    162,
    { maxWidth: 180 }
  );
}

    const barX = margin + 68;
    const barY = 151;
    const barW = 104;

    pdf.setDrawColor(220, 232, 229);
    pdf.setLineWidth(8);
    pdf.line(barX, barY, barX + barW, barY);

    pdf.setDrawColor(138, 183, 170);
    pdf.line(barX, barY, barX + (barW * Math.min(100, impactPercent) / 100), barY);

    // =========================
    // WHY ONBOARDING MATTERS
    // =========================

    pdf.setTextColor(51, 64, 79);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(19);
    pdf.text('Why Onboarding Packs Matter', margin, 196);

    const insightY = 207;

    const insights = [
      {
        title: 'Stronger first impressions',
        body: 'Thoughtful onboarding helps new starters feel welcomed, valued and prepared from day one.'
      },
      {
        title: 'Faster connection',
        body: 'Useful branded items can help employees feel connected to company culture earlier.'
      },
      {
        title: 'Better long-term engagement',
        body: 'Structured onboarding experiences are often linked with stronger retention and confidence.'
      }
    ];

    insights.forEach((item, i) => {
      const y = insightY + i * 24;

      pdf.setFillColor(240, 248, 247);
      pdf.roundedRect(margin, y, 182, 19, 5, 5, 'F');

      // icon circle
      pdf.setFillColor(220, 240, 236);
      pdf.circle(margin + 12, y + 9.5, 7, 'F');

      // tick icon drawn manually to avoid broken symbols
// clean professional tick
pdf.setDrawColor(102, 193, 178);
pdf.setLineWidth(1.8);
pdf.setLineCap('round');
pdf.setLineJoin('round');

pdf.lines(
  [
    [2.8, 2.8],
    [7.2, -8]
  ],
  margin + 6.8,
  y + 10.4,
  [1, 1],
  'S',
  false
);

      // text
      pdf.setTextColor(51, 64, 79);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(10.5);
      pdf.text(item.title, margin + 24, y + 8);

      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(90, 90, 90);
      pdf.setFontSize(8);
      pdf.text(item.body, margin + 24, y + 14, {
        maxWidth: 145
      });
    });

    // footer
    pdf.setTextColor(120, 120, 120);
    pdf.setFontSize(7);
    pdf.text(
      'Concept summary only. Your official quotation and artwork proof will be supplied separately by Kaboom.',
      margin,
      284,
      { maxWidth: 180 }
    );

    // =========================
    // PAGE 2+ — PRODUCTS
    // =========================

    async function addProductPageHeader(title = 'Products Selected') {
      pdf.setFillColor(136, 173, 185);
      pdf.rect(0, 0, pageWidth, 36, 'F');

      await addLogoToPdf(pdf, margin, 7, 48);

      pdf.setTextColor(255, 255, 255);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(18);
      pdf.text(title, 72, 16);

      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(7.5);
      pdf.text('Created with Kaboom Pack Studio', 72, 25);
    }

    pdf.addPage();
    await addProductPageHeader();

    let x = 6;
    let y = 55;

    const cols = 3;
    const cardW2 = 60;
    const cardH2 = 70;
    const gapX = 6;
    const gapY = 8;

    const imageSize = 46;

    for (let i = 0; i < pack.length; i++) {
      const item = pack[i];

      const col = i % cols;

      if (i > 0 && col === 0) {
        x = 6;
        y += cardH2 + gapY;
      }

      if (y + cardH2 > 286) {
        pdf.addPage();
        await addProductPageHeader('Products Selected');
        x = 6;
        y = 55;
      }

      pdf.setFillColor(240, 249, 251);
      pdf.roundedRect(x, y, cardW2, cardH2, 5, 5, 'F');

      // product number
      pdf.setTextColor(150, 165, 170);
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(6);
      pdf.text(String(i + 1).padStart(2, '0'), x + cardW2 - 9, y + 6);

      const imgData = await imageToDataUrl(item.imageSrc);

      if (imgData) {
        try {
          // square image box to prevent distortion
          pdf.addImage(imgData, 'JPEG', x + 7, y + 8, imageSize, imageSize, undefined, 'FAST');
        } catch (e) {
          try {
            pdf.addImage(imgData, 'PNG', x + 7, y + 8, imageSize, imageSize, undefined, 'FAST');
          } catch (err) {
            console.warn('Image skipped in PDF', err);
          }
        }
      }

      const textX = x + 6;
const textW = cardW2 - 12;

pdf.setTextColor(51, 64, 79);
pdf.setFont('helvetica', 'bold');
pdf.setFontSize(6.25);

const titleLines = pdf.splitTextToSize(
  safePdfText(item.title || 'Product'),
  textW
).slice(0, 2);

// Move ONLY the title up if it wraps
const titleY = titleLines.length > 1 ? y + 57 : y + 60;

pdf.text(titleLines, textX, titleY);

pdf.setFont('helvetica', 'normal');
pdf.setFontSize(6);
pdf.setTextColor(90, 90, 90);

// Always keep these aligned
pdf.text(
  `Colour: ${safePdfText(item.colour || 'Not selected')}`,
  textX,
  y + 64,
  { maxWidth: textW }
);

pdf.text(
  `Decoration: ${safePdfText(formatDecoration(item.decoration))}`,
  textX,
  y + 67,
  { maxWidth: textW }
);

      x += cardW2 + gapX;
    }

    // footer on final product page
    pdf.setTextColor(150, 150, 150);
    pdf.setFontSize(6.8);
    pdf.text('www.kaboom-branding.co.uk', margin, 290);

    pdf.setTextColor(150, 150, 150);
    pdf.text('Created with Kaboom Pack Studio', 130, 290);

    pdf.save(`Kaboom-Pack-Studio-${packageName.replace(/\s+/g, '-')}.pdf`);

  } catch (e) {
    console.error('PDF generation failed:', e);
    alert('Sorry, the PDF could not be created. Please try again.');
  } finally {
    btn.disabled = false;
    btn.textContent = originalText;
  }
});
 

 
document.querySelectorAll('.accordion').forEach(acc => {
  const category = acc.dataset.packCategory;
  const label = acc.querySelector('.pack-category-label');

  if (category && label) {
    label.textContent = category;
  }
});


document.addEventListener('click', function(e) {
  const btn = e.target.closest('#continue-saved-pack');
  if (!btn) return;

  e.preventDefault();

  restoreSavedBuilderPack();

  const msg = document.getElementById('saved-pack-message');
  if (msg) msg.style.display = 'none';
});